import React, { useEffect, useState, useMemo } from 'react';
import Container from '../../Container/Container'
import { useNavigate, useLocation, Link } from 'react-router';
import { useForm, Controller } from "react-hook-form";
import { get, ImageUrl } from '../../ApiServices/ApiServices';
import Select from 'react-select';
import { Search } from "lucide-react";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Image } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
// import { setSize, clearSize } from './profileSlice';
import { setSize, clearSize, setShirtSize } from '../../redux/profileSlice';
// import SingleOrder from './SingleOrder';
import { useDebounce } from 'use-debounce';

function GroomStyle({ onSubmit, onNext, onBack, ticket, initialValues }) {
    const { register, handleSubmit, formState: { errors }, control, watch, getValues, trigger, setValue } = useForm({
        defaultValues: initialValues
    });



    console.log(errors, "errors")
    const [debouncedWeight, setDebouncedWeight] = useState(null);

    // Create a debounced version of the weight value
    const [debouncedWeightValue] = useDebounce(watch("Weight"), 800);
    const [data, setdata] = useState([])
    const [sizes, setsizes] = useState([])
    const [sizesCategory, setsizesCategory] = useState([])
    const [showSleeve, setShowSleeve] = useState(true);
    // dll
    const [selectedHeight, setSelectedHeight] = useState(initialValues.Height || "");
    // by aadil
    const [coat, setcoat] = useState('')
    const [sizefilterid, setsizefilterid] = useState('')
    const [AllSize, setAllSize] = useState([])
    const [categoryName, setCategoryName] = useState('');
    const CoatstyleData = JSON.parse(localStorage.getItem('coatStyle'));
    const [Coatstyle, setCoatstyle] = useState(CoatstyleData || null)
    const pantstyleData = JSON.parse(localStorage.getItem('pantstyle'));
    const [Pantstyle, setPantstyle] = useState(pantstyleData || null)
    const shirtstyleData = JSON.parse(localStorage.getItem('shirtstyle'));
    const [Shirtstyle, setShirtstyle] = useState(shirtstyleData || null)
    const [tempCoatSize, setTempCoatSize] = useState(null);
    const VeststyleData = JSON.parse(localStorage.getItem('Veststyle'));
    const [Veststyle, setVeststyle] = useState(VeststyleData || null)
    const [shoesStyle, setshoesStyle] = useState(null)
    const [Tiestyle, setTiestyle] = useState([])
    const [waistSizes, setWaistSizes] = useState([]);
    const [HipSizes, setHipSizes] = useState([]);
    const [NeckSizes, setNeckSizes] = useState([]);
    const [InsleeveSizes, setInsleeveSizes] = useState([]);
    const [ShoesSizes, setshoesSizes] = useState([]);
    const [outseamSizes, setoutseamSizes] = useState([]);
    const [pantStyleSelected, setPantStyleSelected] = useState(false);
    const [name, setname] = useState("")
    const [orderForState, setOrderForState] = useState(initialValues?.order_for);
    const [uniqcoat, setuniqcoat] = useState([])
    const dispatch = useDispatch();
    const Resize = useSelector((state) => state.profile.size);
    const [MatchedItems, setMatchedItems] = useState([])
    const [coattype, setcoattype] = useState("")
    const [nonBoldMessage, setNonBoldMessage] = useState("");
    const [runby, setrunby] = useState(false)
    const navigate = useNavigate()
    const location = useLocation()
    const selectedCoatStyle = watch("Coat");
    const selectedVestStyle = watch("Vest");
    const selectedShoesStyle = watch("Shoes");
    const [disableSleeve, setDisableSleeve] = useState(false); // Track if Sleeve should be disabled
    const coatSizeValidation = selectedCoatStyle ? { required: "Coat Size is required" } : {};
    const insleeveValidation = selectedCoatStyle ? { required: "Insleeve is required" } : {};
    const [orderFor, setOrderFor] = useState(initialValues.order_for || "Men");
    const pantStyleValue = watch("Pant");
    const [shirtStyleSelected, setShirtStyleSelected] = useState(false);
    const [coatid, setCoatid] = useState(localStorage.getItem('coatid'));
    const [sizeid, setSizeid] = useState(localStorage.getItem('size'));
    const [isFirstRun, setIsFirstRun] = useState(true);
    const [selectedCoatSize, setSelectedCoatSize] = useState(null);
    const [defaultsize, setdefaultsize] = useState(null)
    const [Stoprender, setStoprender] = useState(true)
    const [selectedNeckSize, setSelectedNeckSize] = useState(initialValues?.ShirtSize || null);
    const shirtStyleValue = watch("Shirt");
    const [recommendationMessage, setRecommendationMessage] = useState('');
    const [recommendedCategoryDisplay, setRecommendedCategoryDisplay] = useState('');
    const [recommendedCategory, setRecommendedCategory] = useState(null);
    const weight = watch("Weight"); // Ensure weight updates
    const [shirtSize, setShirtSizes] = useState("");
    const [sizeRecommendationMsg, setSizeRecommendationMsg] = useState("");
    const [shirtSizeRecommendationMsg, setShirtSizeRecommendationMsg] = useState("");
    const [vestRecommendationMsg, setVestRecommendationMsg] = useState("");
    const [category, setCategory] = useState("");
    const [allSizes, setAllSizes] = useState([]);
    const ID = location.state?.ID;
    const [originalCategory, setOriginalCategory] = useState(null);



    console.log(initialValues.order_for, "initialValues.order_for")
    useEffect(() => {
        const fetchBoysCoatSizeCategories = async () => {
            // Convert height to inches
            const computedHeightInInches = typeof selectedHeight === 'string' && selectedHeight.includes("'")
                ? convertHeightToInches(selectedHeight)
                : selectedHeight;

            // First, fetch all available categories to display
            try {
                let allCategoriesApi = `all-size-chart-categories`;
                let allCategoriesResponse = await get(allCategoriesApi);

                if (allCategoriesResponse?.status === true) {
                    setAllSizes(allCategoriesResponse.data.filter(
                        category => category.size_charts && category.size_charts.length > 0
                    ));
                }

                // If height < 60 AND coatSize exists (for Boys only), fetch matched categories
                if (computedHeightInInches < 60 && initialValues.coatSize && initialValues.gender === "Boys") {

                    let coatSizeApi = `all-size-chart-categories?coatSize=${initialValues.coatSize}`;
                    let coatSizeResponse = await get(coatSizeApi);

                    if (coatSizeResponse?.status === true) {

                        const validCategories = coatSizeResponse.data.filter(
                            category => category.size_charts && category.size_charts.length > 0
                        );

                        if (validCategories.length > 0) {
                            setMatchedItems(validCategories); // Update matched items for Boys
                        }
                    }
                }
            } catch (err) {
                console.error("Error fetching categories:", err);
            }
        };

        fetchBoysCoatSizeCategories();
    }, [selectedHeight, initialValues.coatSize, initialValues.gender]);

    useEffect(() => {
        setPantStyleSelected(!!pantStyleValue);
    }, [pantStyleValue]);

    useEffect(() => {
        const fetchSizeRecommendation = async () => {
            // Reset recommendation message and category at the beginning of each run
            setRecommendationMessage('');
            setRecommendedCategory(null);
            setRecommendedCategoryDisplay('');

            // Validate inputs - exit early if required fields are missing
            if (!selectedHeight || !selectedCoatSize) {
                return;
            }

            // Get unique coat sizes from the sizes array
            const uniqueCoatSizes = sizes
                .filter(category => category.size_charts.length > 0)
                .flatMap(category => category.size_charts.map(size => size.coatSize));

            // Exit if the coat size is not highlighted (not in uniqueCoatSizes)
            if (!uniqueCoatSizes.includes(selectedCoatSize)) {
                return; // Don't display recommendation for non-highlighted coat sizes
            }

            try {
                // Convert height to inches if it's in feet'inches" format
                const heightInInches = typeof selectedHeight === 'string' && selectedHeight.includes("'")
                    ? convertHeightToInches(selectedHeight)
                    : selectedHeight;
                const weight = watch("Weight"); // Ensure weight updates

                // Track if we're using weight or not for message display
                let usingWeightInRecommendation = true;
                let apiCallSuccessful = false;


                // First attempt with weight parameter if available
                let matchingCategories = await fetchCategoriesWithParams(heightInInches, selectedCoatSize, weight);
                apiCallSuccessful = true;

                // If no matching categories found and weight was provided, try again without weight
                if (matchingCategories.length === 0 && weight && !isNaN(Number(weight))) {
                    matchingCategories = await fetchCategoriesWithParams(heightInInches, selectedCoatSize, null);
                    // Set flag to not use weight in message when we had to retry without weight
                    usingWeightInRecommendation = false;
                }

                // Only proceed if we have successful API response
                if (!apiCallSuccessful) {
                    return;
                }

                // Process matching categories if any found
                if (matchingCategories.length > 0) {
                    // Get the first matching category
                    const recommendedCategory = matchingCategories[0];

                    // Replace category name if it starts with "E"
                    if (recommendedCategory.name && recommendedCategory.name.charAt(0).toUpperCase() === 'E') {
                        recommendedCategory.name = 'XL';
                    }

                    // Safety check for recommendedCategory.name
                    if (!recommendedCategory.name) {
                        return;
                    }

                    // Check if the recommended category matches the already selected category
                    const isRecommendedCategoryAlreadySelected =
                        recommendedCategory.name === categoryName;

                    // Only set recommendation message and category if not already selected
                    if (!isRecommendedCategoryAlreadySelected) {
                        setRecommendedCategory(recommendedCategory);

                        // Create recommendation message
                        const categoryInitial = recommendedCategory.name
                            ? recommendedCategory.name.charAt(0).toUpperCase()
                            : '';

                        const weightSpecified = weight && !isNaN(Number(weight)) && usingWeightInRecommendation;
                        setCategory(categoryInitial)
                        // Only set the message once
                        setRecommendationMessage(
                            `✅ Recommended Coat Size: ${selectedCoatSize}${categoryInitial} for Height: ${convertInchesToFeetInches(heightInInches)}` +
                            (weightSpecified ? `, Weight: ${weight} ` : ' ')
                        );
                    }
                } else {
                    // Clear any previous recommendations if no matches found
                    // if (!recommendationMessage) {
                    setRecommendedCategory(null);
                    setRecommendedCategoryDisplay('');
                    setRecommendationMessage('');
                    // }
                }
            } catch (err) {
                console.error('Error fetching size recommendations:', err);
                // if (!recommendationMessage) {
                setRecommendationMessage('Error fetching size recommendations');
                setRecommendedCategory(null);
                setRecommendedCategoryDisplay('');
                // }
            }
        };

        // Helper function to fetch categories with specified parameters
        const fetchCategoriesWithParams = async (heightInInches, coatSize, weight) => {
            try {
                // Construct the API URL
                const apiParams = new URLSearchParams();
                apiParams.append('height', heightInInches);
                apiParams.append('coatSize', coatSize);

                // Only add weight if it's provided and valid
                if (weight && !isNaN(Number(weight))) {
                    apiParams.append('weight', weight);
                }

                const api = `all-size-chart-categories?${apiParams.toString()}`;
                const response = await get(api);

                if (response?.status === true && response.data.length > 0) {
                    // Filter categories that match the criteria
                    return response.data.filter(category =>
                        category.size_charts &&
                        category.size_charts.some(chart =>
                            chart.coatSize === coatSize &&
                            (!chart.minHeight || heightInInches >= chart.minHeight) &&
                            (!chart.maxHeight || heightInInches <= chart.maxHeight) &&
                            // Only check weight if it's provided and valid
                            (
                                weight && !isNaN(Number(weight)) ?
                                    (!chart.minWeight || Number(weight) >= chart.minWeight) &&
                                    (!chart.maxWeight || Number(weight) <= chart.maxWeight)
                                    : true
                            )
                        )
                    );
                }
                return [];
            } catch (err) {
                console.error('Error in fetchCategoriesWithParams:', err);
                return [];
            }
        };

        const convertInchesToFeetInches = (inches) => {
            const feet = Math.floor(inches / 12);
            const remainingInches = inches % 12;
            return `${feet}'${remainingInches}"`;
        };

        // Use a debounced version of the fetch function to prevent rapid multiple calls
        const debouncedFetch = debounce(fetchSizeRecommendation, 300);
        debouncedFetch();

        // Cleanup function to cancel any pending debounced calls when dependencies change
        return () => {
            debouncedFetch.cancel();
        };
    }, [selectedHeight, selectedCoatSize, watch, categoryName, MatchedItems, initialValues]);

    // Debounce function to prevent multiple rapid executions
    function debounce(func, wait) {
        let timeout;
        const debounced = function (...args) {
            const later = () => {
                clearTimeout(timeout);
                func.apply(this, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };

        debounced.cancel = function () {
            clearTimeout(timeout);
        };

        return debounced;
    }
    useEffect(() => {
        // Update the state based on whether Shirt Style is selected
        setShirtStyleSelected(!!shirtStyleValue);
    }, [shirtStyleValue]);


    const handleBack = () => {
        const currentValues = getValues();
        onBack(currentValues);
    };
    const ViewState = async () => {
        try {
            const api = `all-inventories?size=${1000}`;
            const response = await get(api);
            if (response?.status == true) {
                setdata(response.data?.rows);
            }
        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
            console.error('Errordsfdsfd:', err);
        } finally {
        }
    };
    useEffect(() => {
        ViewState();

    }, []);

    const handleHeightChange = (event) => {
        setSelectedHeight(event.target.value); // Update state with selected height
    };



    const Allsize = async () => {
        try {
            const api = `all-size-charts`;
            const response = await get(api);
            setAllSize(response?.data)

        }
        catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        }

    }
    useEffect(() => {
        Allsize()
    }, [])
    useEffect(() => {
        setDebouncedWeight(debouncedWeightValue);
    }, [debouncedWeightValue]);



    const size = async () => {
        try {
            const heightInInches = typeof selectedHeight === 'string' && selectedHeight.includes("'")
                ? convertHeightToInches(selectedHeight)
                : selectedHeight;
            let weightValue = watch("Weight");

            // First API call with both height and weight
            let api = heightInInches < 60 // Less than 5' (60 inches)
                ? `all-size-chart-categories?name=Boys&height=${initialValues.Height}&weight=${debouncedWeight}`
                : `all-size-chart-categories?name=Short,Regular,Long,Extra Long&height=${heightInInches}&weight=${debouncedWeight}`;

            let response = await get(api);

            if (response?.status == true) {
                // Filter out categories with empty size charts
                const filteredCategories = response.data.filter(
                    category => category.size_charts && category.size_charts.length > 0
                );
                // If we have valid categories, store the first one as our original
                if (filteredCategories.length > 0) {
                    setOriginalCategory(filteredCategories[0].name);
                }

                // Remove unnecessary delay
                // await new Promise(resolve => setTimeout(resolve, 4000))

                // If filteredCategories is empty, call API again without weight parameter
                if (!filteredCategories || filteredCategories.length === 0) {

                    // Removing weight parameter from API call
                    api = heightInInches < 60
                        ? `all-size-chart-categories?name=Boys&height=${initialValues.Height}`
                        : `all-size-chart-categories?name=Short,Regular,Long,Extra Long&height=${heightInInches}`;

                    response = await get(api);

                    if (response?.status == true) {
                        const newFilteredCategories = response.data.filter(
                            category => category.size_charts && category.size_charts.length > 0
                        );

                        if (newFilteredCategories.length > 0 && !originalCategory) {
                            setOriginalCategory(newFilteredCategories[0].name);
                        }
                        setsizes(response.data);
                        setMatchedItems(newFilteredCategories);
                    }
                } else {
                    // Original processing if filteredCategories has data
                    setsizes(response.data);
                    setMatchedItems(filteredCategories);

                    // Only set these if needed
                    // if (filteredCategories.length > 0) {
                    //     setcoattype(filteredCategories[0].name);
                    //     setuniqcoat(filteredCategories[0].size_charts);
                    // }
                }

                response.data
                    .filter(category => category.size_charts.length > 0)
                    .forEach(category => {
                        setcoattype(category.name);
                        setuniqcoat(category.size_charts)
                    });

                // Find the first valid size chart ID
                let idToStore = null;
                for (const item of response.data) {
                    if (item.size_charts && item.size_charts.length > 0) {
                        idToStore = item.id;
                        break; // Exit the loop once we find the first matching object
                    }
                }

                setSizeid(idToStore);
                setStoprender(true);
                dispatch(setSize(idToStore));
                setValue("size_chart_category_id", idToStore);
                setsizefilterid(idToStore);
            }
        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
            console.error('Error:', err);
        } finally {
        }
    };


    const convertHeightToInches = (heightString) => {
        const [feet, inches] = heightString.split("'").map(part =>
            parseInt(part.replace(/['']/g, ''), 10)
        );
        return (feet * 12) + (inches || 0);
    };

    useEffect(() => {
        const height = selectedHeight || initialValues?.Height;
        const weight = watch("Weight");

        // Condition to fetch size charts (only when weight is available)
        // const shouldFetchSizeCharts =
        //     height &&
        //     (
        //         (orderForState === "Boys" && selectedHeight < 60) ||
        //         (orderForState === "Men" && selectedHeight >= 60)
        //     ) &&
        //     debouncedWeight;

        if (height) {
            size();
        }

    }, [selectedHeight, initialValues?.Height, debouncedWeight]);


    const category1Data = data?.filter((item) => item.category_id === 1);
    const pants = data?.filter((item) => item.category_id === 2);
    const Shirt = data?.filter((item) => item.category_id === 3);
    const Vest = data?.filter((item) => item.category_id === 4);
    const Tie = data?.filter((item) => item.category_id === 5);
    const Shoes = data?.filter((item) => item.category_id === 7);

    const Pocket = data?.filter((item) => item.category_id === 8);
    const Jewelry = data?.filter((item) => item.category_id === 9);


    const heightOptions = [];
    for (let feet = 3; feet <= 6; feet++) {
        for (let inches = 1; inches <= 11; inches++) {
            const totalInches = (feet * 12) + inches; // Convert to total inches

            heightOptions.push({
                display: `${feet}'${inches}''`, // Display format
                value: totalInches // Value in inches
            });
        }
    }

    const weightValue = watch("Weight"); // Ensure weight updates

    useEffect(() => {
        if (!categoryName || !selectedCoatSize || !selectedHeight) {

            setNonBoldMessage("");
            // Clear message if essential values are missing
            return;
        }

        // Convert height to feet & inches format
        const feet = Math.floor(selectedHeight / 12);
        const inches = selectedHeight % 12;
        const formattedHeight = `${feet}'${inches}"`;

        let categoryInitial = "";
        const categoryToUse = originalCategory || categoryName;

        if (categoryToUse) {
            // For Extra Long, use XL, otherwise use first letter
            if (categoryToUse.startsWith("Extra")) {
                categoryInitial = "XL";
            } else {
                categoryInitial = categoryToUse.charAt(0);
            }
        }

        const uniqueCoatSizes = sizes
            .filter(category => category.size_charts.length > 0)
            .flatMap(category => category.size_charts.map(size => size.coatSize));
        if (uniqueCoatSizes.includes(selectedCoatSize)) {
            setNonBoldMessage("");
            return;
        }

        const isWeightValid = weightValue !== null && weightValue !== undefined && !isNaN(weightValue) && weightValue !== "";
        // const weightText = isWeightValid ? ` and weight ${weightValue}` : '';

        // Find all coat sizes that match the height range
        const validSizeCharts = sizes
            .flatMap(category => category.size_charts)
            .filter(size =>
                size.minHeight !== null &&
                size.maxHeight !== null &&
                selectedHeight >= size.minHeight &&
                selectedHeight <= size.maxHeight
            );
        // Additional check to see if weight is within the range for any coat size
        let isWeightInRange = false;
        if (isWeightValid) {
            isWeightInRange = validSizeCharts.some(chart =>
                (!chart.minWeight || Number(weightValue) >= chart.minWeight) &&
                (!chart.maxWeight || Number(weightValue) <= chart.maxWeight)
            );
        }
        // let categoryInitial = "";
        // if (categoryName) {
        //     categoryInitial = categoryName.charAt(0).toUpperCase() === "E" ? "XL" : categoryName.charAt(0);
        // }
        // Only include weight in the message if it's valid AND in range
        const weightText = (isWeightValid && isWeightInRange) ? `, Weight: ${weightValue}` : '';
        // if (validSizeCharts.length === 0) {
        //     // If no matching size chart, show the range of available coat sizes
        //     const allSizes = sizes.flatMap(category => category.size_charts.map(size => size.coatSize));
        //     const minSize = Math.min(...allSizes);
        //     const maxSize = Math.max(...allSizes);

        //     console.log(minSize, "minSizeminSize", "maxSizemaxSize", maxSize);

        //     if (minSize === maxSize) {
        //         setNonBoldMessage(`✅ Recommended  Coat Size ${minSize}${categoryInitial} for height ${formattedHeight}${weightText}`);
        //     } else {
        //         setNonBoldMessage(`✅ Recommended Coat Size ${minSize} to ${maxSize} for height ${formattedHeight}${weightText}`);
        //     }
        //     return;
        // }

        // Find the selected coat size chart details


        if (validSizeCharts.length === 0) {
            // If no matching size chart, show the range of available coat sizes
            const allSizes = sizes
                .flatMap(category => category.size_charts.map(size => size.coatSize))
                .filter(size => !isNaN(parseInt(size)))
                .map(size => parseInt(size));

            if (allSizes.length > 0) {
                const minSize = Math.min(...allSizes);
                const maxSize = Math.max(...allSizes);


                if (minSize === maxSize) {
                    setNonBoldMessage(`✅ Recommended Coat Size ${minSize}${categoryInitial} for height ${formattedHeight}${weightText}`);
                } else {
                    setNonBoldMessage(`✅ Recommended Coat Size ${minSize} to ${maxSize} for height ${formattedHeight}${weightText}`);
                }
            }
            return;
        }

        const selectedSizeChart = validSizeCharts.find(size => size.coatSize === selectedCoatSize);

        if (!selectedSizeChart) {
            // If selected coat size is not found, recommend the full range of valid coat sizes
            const availableSizes = validSizeCharts
                .map(size => size.coatSize)
                .filter(size => !isNaN(parseInt(size)))
                .map(size => parseInt(size))
                .sort((a, b) => a - b);

            if (availableSizes.length > 0) {
                const minAvailableSize = availableSizes[0];
                const maxAvailableSize = availableSizes[availableSizes.length - 1];

                if (minAvailableSize === maxAvailableSize) {
                    setNonBoldMessage(`✅ Recommended Coat Size ${minAvailableSize}${categoryInitial} for height ${formattedHeight}${weightText}`);
                } else {
                    setNonBoldMessage(`✅ Recommended Coat Size ${minAvailableSize} to ${maxAvailableSize} for height ${formattedHeight}${weightText}`);
                }
            }
        }


    }, [categoryName, selectedHeight, weightValue, sizes]); // Ensure reactivity
    // In component initialization, load saved messages and values
    useEffect(() => {
        // Restore saved values when component mounts
        const savedCoatSize = localStorage.getItem('selectedCoatSize');
        const savedCategoryName = localStorage.getItem('selectedCategoryName');
        const savedRecommendationMessage = localStorage.getItem('recommendationMessage');
        const savedNonBoldMessage = localStorage.getItem('nonBoldMessage');

        if (savedCoatSize) {
            setSelectedCoatSize(savedCoatSize);
        }

        if (savedCategoryName) {
            setCategoryName(savedCategoryName);
        }

        if (savedRecommendationMessage) {
            setRecommendationMessage(savedRecommendationMessage);
        }

        if (savedNonBoldMessage) {
            setNonBoldMessage(savedNonBoldMessage);
        }

        // Clean up function
        return () => {
            // Save current values before unmounting
            if (recommendationMessage) {
                localStorage.setItem('recommendationMessage', recommendationMessage);
            }

            if (nonBoldMessage) {
                localStorage.setItem('nonBoldMessage', nonBoldMessage);
            }
        };
    }, []);

    useEffect(() => {
        if (coatid && sizeid) {
            sizeChartCategory();
        }
    }, [coatid, sizeid]);
    const sizeChartCategory = async () => {
        try {

            const api = `view-size-chart-category/${sizeid}?coatSize=${coatid}`;
            const response = await get(api);
            if (response?.status == true) {
                setsizesCategory(response.data?.size_charts);
                setCategoryName(response.data?.name || '');
                localStorage.setItem('categoryName', response.data?.name || '');
                // if (response.data?.name) {
                //     localStorage.setItem('selectedCategoryName', response.data.name);
                // }

                FuncForNotVAlid()
                if (response.data?.name == "Boys") {
                    // setOrderForState("Boys")

                }
                else {
                    // setOrderForState("Men")

                }
                setValue("coat_size_chart_id", response?.data.size_charts[0].id);



                if (response.data?.name || coatid) {
                    let defaultValue = ""; // Initialize a variable to hold the default value
                    // First switch statement based on response.data?.name
                    switch (response.data?.name) {
                        case "Short":
                            defaultValue = "16";
                            break;
                        case "Long":
                            defaultValue = "18";
                            break;
                        case "Extra Long":
                            defaultValue = "19";
                            break;
                        case "Regular":
                            defaultValue = "17";
                            break;
                        default:
                            // If response.data?.name doesn't match, check coatid
                            switch (coatid) {
                                case "3":
                                    defaultValue = "9";
                                    break;
                                case "4":
                                    defaultValue = "9.5";
                                    break;
                                case "6":
                                    defaultValue = "11";
                                    break;
                                case "8":
                                    defaultValue = "12.5";
                                    break;
                                case "10":
                                    defaultValue = "13";
                                    break;
                                case "12":
                                    defaultValue = "14.25";
                                    break;
                                case "14":
                                    defaultValue = "15";
                                    break;
                                case "16":
                                    defaultValue = "16";
                                    break;
                                case "18":
                                    defaultValue = "16.5";
                                    break;
                                default:
                                    defaultValue = ""; // Fallback value if none of the conditions match
                                    break;
                            }
                            break;
                    }
                    setdefaultsize(defaultValue)
                    // Set the value for the field
                    setValue("Insleeve", defaultValue); // Ensure the field name matches your form field
                    console.log(defaultValue, "defaultValue123");

                }



                if (response?.data.size_charts.length > 0) {
                    const minWaist = parseInt(response?.data.size_charts[0].minWaist);
                    const maxWaist = parseInt(response?.data.size_charts[0].maxWaist);
                    const sizes = [];
                    for (let i = minWaist; i <= maxWaist; i++) {
                        sizes.push(i);
                    }

                    setWaistSizes(sizes);

                }
                if (response?.data.size_charts.length > 0) {
                    const minNeck = parseInt(response?.data.size_charts[0].minNeck);
                    const maxNeck = parseInt(response?.data.size_charts[0].maxNeck);
                    const sizes = [];
                    for (let i = minNeck; i <= maxNeck; i++) {
                        sizes.push(i);
                    }
                    setNeckSizes(sizes);

                }
                if (response?.data.size_charts.length > 0) {
                    const minShirtSleeve = parseInt(response?.data.size_charts[0].minShirtSleeve);
                    const maxShirtSleeve = parseInt(response?.data.size_charts[0].maxShirtSleeve);
                    const sizes = [];
                    for (let i = minShirtSleeve; i <= maxShirtSleeve; i++) {
                        sizes.push(i);
                    }
                    setInsleeveSizes(sizes);
                }
                if (response?.data.size_charts.length > 0) {
                    const minShoe = parseInt(response?.data.size_charts[0].minShoe);
                    const maxShoe = parseInt(response?.data.size_charts[0].maxShoe);
                    const sizes = [];
                    for (let i = minShoe; i <= maxShoe; i++) {
                        sizes.push(i);
                    }
                    setshoesSizes(sizes);
                }
                if (response?.data.size_charts.length > 0) {
                    const minOutseam = parseInt(response?.data.size_charts[0].minOutseam);
                    const maxOutseam = parseInt(response?.data.size_charts[0].maxOutseam);
                    const sizes = [];
                    for (let i = minOutseam; i <= maxOutseam; i++) {
                        sizes.push(i);
                    }
                    setoutseamSizes(sizes);
                }
                // setshoesSizes
                if (response?.data.size_charts.length > 0) {
                    const minHip = parseInt(response?.data.size_charts[0].minHip);
                    const maxHip = parseInt(response?.data.size_charts[0].maxHip);
                    const sizes = [];
                    for (let i = minHip; i <= maxHip; i++) {
                        sizes.push(i);
                    }
                    setHipSizes(sizes);
                }
            }
        } catch (err) {
            setWaistSizes([]);
            setHipSizes([])
            setNeckSizes([]);
            setInsleeveSizes([])
            setshoesSizes([])
            setoutseamSizes([])
            FuncForNotVAlid()
            console.error('Errordsfdsfd:', err);
        } finally {
        }
    };

    const handlejwellaryChange = (e) => {
        const selectedStyle = Jewelry.find(item => item.style === e.target.value);
        if (selectedStyle) {
            setValue("jewelryinventory_id", selectedStyle.id);

        }

    }

    const handleTie = (e) => {
        const selectedStyle = Tie.find(item => item.style == e.target.value);
        if (selectedStyle) {
            setValue("TieInventory_id", selectedStyle.id);
        }
    }

    const handlePocket = (e) => {
        // Get the combined value from the event
        const selectedPocketString = e.target.value; // This is `${item.style} ${item.description}`

        // Find the matching pocket style in the Pocket array
        const selectedStyle = Pocket.find(item => `${item.style}` == selectedPocketString);

        if (selectedStyle) {
            // Update the form state or other logic
            setValue("PocketInventory_id", selectedStyle.id); // Set the inventory ID
            setValue("Pocket", e.target.value, { shouldValidate: true }); // Update form value

            // You can do something with the selected style here if needed
            // setPocketStyle(selectedStyle);
        } else {
            console.error("Selected pocket style not found in Pocket array.");
            // Handle the case where no matching pocket style is found
        }
    };
    const handleCoatChange = (selectedOption) => {
        // selectedOption is the entire option object, not an event

        if (selectedOption) {
            // Find the selected item from category1Data
            const selectedStyle = category1Data.find(item => item.style === selectedOption.value);
            const serializedData = JSON.stringify(selectedStyle);
            localStorage.setItem('coatStyle', serializedData);

            // Do something with the selected style
            setValue("coatinventory_id", selectedStyle.id);

            setCoatstyle(selectedStyle); // Update state with the selected style

        } else {
            // Handle the case where the selection is cleared
            setCoatstyle(null); // Reset the state
        }
    };
    const handlePaintChange = (e) => {
        // Split the combined value to extract the style
        const selectedStyleString = e.target.value; // This is `${item.style} ${item.description}`
        const selectedStyle = pants.find(item => `${item.style}` == selectedStyleString);

        if (selectedStyle) {
            setValue("Paintinventory_id", selectedStyle.id); // Set the inventory ID
            setPantstyle(selectedStyle); // Update state with the selected style
            const serializedData = JSON.stringify(selectedStyle);
            localStorage.setItem('pantstyle', serializedData); // Save to localStorage
            setValue("Pant", e.target.value, { shouldValidate: true }); // Update form value
        } else {
            console.error("Selected style not found in pants array.");
            localStorage.removeItem('pantstyle'); // Remove stored data
            setValue("Paintinventory_id", ""); // Clear the ID
            setPantstyle(null); // Reset state
            setValue("Pant", ""); // Update form value

            // Handle the case where no matching style is found
        }
    };
    const handleShirtChange = (e) => {
        // Get the combined value from the event
        const selectedShirtString = e.target.value; // This is `${item.style} ${item.description}`

        // Find the matching shirt in the shirts array
        const selectedShirt = sortedShirts.find(item => `${item.style}` == selectedShirtString);

        if (selectedShirt) {
            // Update the form state or other logic
            setValue("shirtInventory_id", selectedShirt.id); // Set the inventory ID
            // setShirtStyle(selectedShirt); // Update state with the selected shirt style
            const serializedData = JSON.stringify(selectedShirt);
            localStorage.setItem('shirtstyle', serializedData); // Save to localStorage
            setValue("Shirt", e.target.value, { shouldValidate: true }); // Update form value
        } else {
            setValue("shirtInventory_id", ""); // Set the inventory ID
            // setShirtStyle(selectedShirt); // Update state with the selected shirt style
            // const serializedData = JSON.stringify(selectedShirt);
            localStorage.removeItem('shirtstyle'); // Save to localStorage
            setValue("Shirt", ""); // Update form value
            console.error("Selected shirt not found in shirts array.");
            // Handle the case where no matching shirt is found
        }
    };
    const handleVestChange = (e) => {
        // Find the selected item from category1Data
        const selectedStyle = Vest.find(item => item.style == e.target.value) || null;
        setValue("Vest", e.target.value, { shouldValidate: true });
        // const serializedData = JSON.stringify(selectedStyle);
        // localStorage.setItem('Veststyle', serializedData);
        // console.log(selectedStyle, "selectedStyle");
        // setValue("VestInventory_id", selectedStyle.id);
        // setVeststyle(selectedStyle)
        if (selectedStyle) {

            // Store valid JSON in localStorage
            localStorage.setItem('Veststyle', JSON.stringify(selectedStyle));

            // Safely set value if selectedStyle is not null
            setValue("VestInventory_id", selectedStyle.id);
            setVeststyle(selectedStyle);
        } else {
            // Handle case where user clears the selection
            setValue("Vest", "");

            localStorage.removeItem('Veststyle'); // Remove stored data
            setValue("VestInventory_id", ""); // Clear the ID
            setVeststyle(null); // Reset state
            console.warn("Vest selection cleared.");
        }
    };
    const handleShoes = (e) => {
        // Get the combined value from the event
        const selectedShoesString = e.target.value; // This is `${item.style} ${item.description}`

        // Find the matching shoes in the Shoes array
        const selectedStyle = Shoes.find(item => `${item.style}` == selectedShoesString);

        if (selectedStyle) {
            // Update the form state or other logic
            setValue("ShoesInventory_id", selectedStyle.id); // Set the inventory ID
            setValue("Shoes", e.target.value, { shouldValidate: true }); // Update form value

            // You can do something with the selected style here if needed
            // setShoesStyle(selectedStyle);
        } else {
            console.error("Selected shoes not found in Shoes array.");
            // Handle the case where no matching shoes are found
        }
    };

    const fetchInventoryDatatwi = async () => {
        try {
            const api = `all-inventory-categories`;
            const totalData = await get(api);



        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }


        } finally {
        }
    };
    useEffect(() => {
        fetchInventoryDatatwi()
    }, [])
    const options = category1Data.map(item => ({
        value: item.style,
        label: `${item.style} ${item.description}`
    }));

    // const heightSelectOptions = heightOptions.map(height => ({
    //     value: height.value,
    //     label: height.display
    // }));


    // Create a function to filter or disable height options
    const getHeightOptions = () => {
        // First create the base options
        const baseOptions = heightOptions.map(height => {
            const heightValue = String(height.value); // Convert to string to ensure includes() works

            // Parse the height value to get height in inches
            let heightInches = 0;

            if (heightValue === "Unknown") {
                // Handle "Unknown" case
                heightInches = 0;
            } else if (typeof heightValue === 'string' && heightValue.includes("'")) {
                // Handle format like "5'10"
                const parts = heightValue.split("'");
                const feet = parseInt(parts[0], 10) || 0;
                const inches = parseInt(parts[1], 10) || 0;
                heightInches = feet * 12 + inches;
            } else if (typeof heightValue === 'string') {
                // Try to parse as just inches if it doesn't match the expected format
                heightInches = parseInt(heightValue, 10) || 0;
            }

            // For "Men": enable options >= 5' and disable < 5'
            // For "Boys": enable options < 5' and disable >= 5'
            // const isDisabled =
            //     (orderForState === "Men" && heightInches < 60) || // 5' = 60 inches
            //     (orderForState === "Boys" && heightInches >= 60);

            return {
                value: height.value,
                label: height.display,
                // isDisabled: isDisabled
            };
        });

        // Add Unknown option which is always enabled
        return [
            { value: "Unknown", label: "Unknown", isDisabled: false },
            ...baseOptions
        ];
    };

    const coatSizeOptions = sizes
        .filter(category => category.size_charts.length > 0) // Filter out categories with no sizes
        .flatMap(category =>
            category.size_charts.map(size => ({
                value: size.coatSize, // Use coatSize as the value
                label: size.coatSize, // Use coatSize as the label
            }))
        );

    const sortedOptions = [...options].sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true }));
    const sortedPants = [...pants].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedShirts = [...Shirt].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedVest = [...Vest].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedTie = [...Tie].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedPocketSquare = [...Pocket].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedJewelry = [...Jewelry].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );
    const sortedShoes = [...Shoes].sort((a, b) =>
        a.style.localeCompare(b.style, undefined, { numeric: true })
    );


    const customComponents = {
        DropdownIndicator: (props) => (
            <div {...props} style={{ padding: "5px", display: "flex", alignItems: "center" }}>
                <Search size={16} />
            </div>
        ),
    };
    // Add this function to your component
    const getShirtSize = (neck, sleeve) => {
        if (!neck) return "";

        const neckValue = Number(neck);

        const sleeveValue = sleeve ? Number(sleeve) : null; // Convert only if sleeve exists

        // if (orderForState === "Boys" || !sleeveValue) {
        //     if (neckValue >= 10 && neckValue <= 10.5) return "BXS";
        //     if (neckValue >= 11 && neckValue <= 11.5) return "BS";
        //     if (neckValue >= 12 && neckValue <= 12.5) return "BM";
        //     if (neckValue >= 13 && neckValue <= 13.5) return "BL";
        //     return ""; // Return empty if no match
        // }
        // Boys sizing logic (neck size <= 13.5)
        if (neckValue < 13) {
            if (neckValue >= 10 && neckValue <= 10.5) return "BXS";
            if (neckValue >= 11 && neckValue <= 11.5) return "BS";
            if (neckValue >= 12 && neckValue <= 12.5) return "BM";
            // if (neckValue >= 13 && neckValue <= 13.5) return "BL";
            return ""; // Return empty if no match
        }
        // ✅ Special case: 13 / 13.5 without sleeve = Boys' Large (BL)
        if ((neckValue === 13 || neckValue === 13.5) && !sleeveValue) {
            return "BL";
        }

        const shirtMapping = {
            13: { 30: "XS1", 32: "XS3" },
            14: { 30: "S1", 32: "S3", 34: "S5", 36: "S7" },
            15: { 30: "M1", 32: "M3", 34: "M5", 36: "M7", 38: "M9" },
            16: { 30: "L1", 32: "L3", 34: "L5", 36: "L7", 38: "L9" },
            17: { 30: "XL1", 32: "XL3", 34: "XL5", 36: "XL7", 38: "XL9" },
            18: { 30: "2XL1", 32: "2XL3", 34: "2XL5", 36: "2XL7", 38: "2XL9" },
            19: { 32: "3XL3", 34: "3XL5", 36: "3XL7", 38: "3XL9" },
            20: { 32: "4XL3", 34: "4XL5", 36: "4XL7", 38: "4XL9" },
            22: { 32: "5XL3", 34: "5XL5", 36: "5XL7", 38: "5XL9" },
            24: { 34: "6XL5", 36: "6XL7", 38: "6XL9" },
            26: { 34: "7XL5", 36: "7XL7", 38: "7XL9" }
        };




        const neckKey = Math.round(neckValue);
        // Find the closest mapping for sleeve size (floor to nearest even number)
        const sleeveKey = sleeveValue ? Math.round(sleeveValue / 2) * 2 : null;
        return shirtMapping[neckKey]?.[sleeveKey] || "";

    };
    // Add these arrays to your component, outside any functions
    const boysShoeSizes = [
        "1K", "2K", "3K", "4K", "5K", "6K", "7K", "8K", "9K", "10K", "11K", "12K", "13K", "10D", "10W", "10.5D", "10.5W", "11D", "11W", "11.5D", "11.5W",
        "12D", "12W", "13D", "13W", "14D", "14W", "15D", "15W",
        "16D", "16W", "17D", "17W", "18D", "18W"
    ];

    const ShoeSizes = [
        "1K", "2K", "3K", "4K", "5K", "6K", "7K", "8K", "9K", "10K", "11K", "12K", "13K", "10D", "10W", "10.5D", "10.5W", "11D", "11W", "11.5D", "11.5W",
        "12D", "12W", "13D", "13W", "14D", "14W", "15D", "15W",
        "16D", "16W", "17D", "17W", "18D", "18W"
    ];
    const mensShoeSizes = [

    ];

    // Then in your render function for the ShoesSize dropdown:


    useEffect(() => {
        // Get current values from the form
        const neckValueRaw = watch("ShirtSize");
        const sleeveValue = watch("Sleeve");

        const neckValue = neckValueRaw ? Number(neckValueRaw.split("/")[0]) : null;


        // if (!neckValue) return; // Exit if no neck value
        // Check if it's a Boys order
        // const isBoyOrder = orderForState === "Boys" || (coatid && parseInt(coatid) <= 18) || (neckValue && neckValue < 13);

        // // Disable sleeve dropdown for Boys orders
        // setDisableSleeve(isBoyOrder);
        // setShowSleeve(!(isBoyOrder || (neckValue === 13 || neckValue === 13.5) && !watch("Sleeve")));



        // Calculate shirt size
        // Calculate shirt size
        // let calculatedShirtSize = "";
        // if (isBoyOrder) {
        //     // For Boys, only use neck size
        //     calculatedShirtSize = getShirtSize(neckValue, null);
        // } else {
        //     // For Men, use both neck and sleeve
        //     calculatedShirtSize = getShirtSize(neckValue, sleeveValue);
        // }

        let calculatedShirtSize = isBoyOrder ? getShirtSize(neckValue, null) : getShirtSize(neckValue, sleeveValue);




        setDisableSleeve(false); // Ensure the sleeve dropdown remains enabled
        setShirtSizes(calculatedShirtSize || "");

        // Make sure we're passing a string to the reducer
        // if (calculatedShirtSize) {
        dispatch(setShirtSize(calculatedShirtSize));
        // }
    }, [watch("ShirtSize"), watch("Sleeve"), coatid, selectedHeight, initialValues.Height]);





    const isBoyOrder = useMemo(() => {
        const coatSizeValue = watch("CoatSize");

        if (!coatSizeValue) return false; // Default to Men's order if no size is selected

        // If coat size is between 3 and 18, classify as Boys
        if (coatSizeValue >= 3 && coatSizeValue <= 18) {
            return true; // Boy Order
        }

        return false; // Otherwise, it's a Men's order
    }, [watch("CoatSize")]);


    // Example of updating localStorage and state



    const FuncForNotVAlid = async () => {
        try {
            const api = `all-size-chart-categories?coatSize=${coatid}`;
            const response = await get(api);
            if (response?.status == true) {
                let matchedItems = [];
                let recommendationMessage = "";
                let isFirstMatch = true;
                const storedCategoryName = localStorage.getItem('selectedCategoryName');

                // Loop through each size category
                for (const item of response.data) {
                    // Check if the item has size charts
                    if (item.size_charts && item.size_charts.length > 0) {
                        // Loop through the size charts of this category
                        for (const sizeChart of item.size_charts) {
                            // Check if the coat size matches the target ID
                            if (sizeChart.coatSize === coatid) {
                                // Add this entire size category to the matches
                                matchedItems.push(item);

                                // Also store the id in localStorage for backward compatibility
                                if (isFirstMatch) {
                                    const rever = localStorage.getItem('size');

                                    if (Stoprender) {
                                        // alert("9999999999");

                                        if (isFirstRun && rever) {
                                            // alert("ooo")
                                            setValue("size_chart_category_id", rever);
                                            dispatch(setSize(rever));
                                            setSizeid(rever);
                                            // If we're restoring a previous size, find and set the category name
                                            const categoryItem = response.data.find(cat => cat.id === rever);
                                            if (categoryItem) {
                                                setCategoryName(categoryItem.name);
                                                localStorage.setItem('selectedCategoryName', categoryItem.name);
                                            } else if (storedCategoryName) {
                                                // Use stored category name as fallback
                                                setCategoryName(storedCategoryName);
                                            }
                                        } else {
                                            // If stored category exists, find the matching category ID
                                            if (storedCategoryName) {
                                                const storedCategory = response.data.find(cat => cat.name === storedCategoryName);
                                                if (storedCategory) {
                                                    setValue("size_chart_category_id", storedCategory.id);
                                                    dispatch(setSize(storedCategory.id));
                                                    setSizeid(storedCategory.id);
                                                    setCategoryName(storedCategoryName);
                                                } else {
                                                    setValue("size_chart_category_id", item.id);
                                                    dispatch(setSize(item.id));
                                                    setSizeid(item.id);
                                                    setCategoryName(item.name);
                                                    localStorage.setItem('selectedCategoryName', item.name);
                                                }
                                            } else {
                                                setValue("size_chart_category_id", item.id);
                                                dispatch(setSize(item.id));
                                                setSizeid(item.id);
                                                setCategoryName(item.name);
                                                localStorage.setItem('selectedCategoryName', item.name);
                                            }
                                        }

                                        setIsFirstRun(false);  // Update state (triggers re-render if needed)
                                        setStoprender(true);
                                        isFirstMatch = false;
                                    }

                                }

                                break; // Exit the size charts loop once a match is found in this category
                            }
                        }
                    }

                }

                // Update the state with all matched items at once
                setMatchedItems(matchedItems);


            }
        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
        }
    }

    useEffect(() => {
        if (coatid) {
            // Load stored category name if available
            const storedCategoryName = localStorage.getItem('selectedCategoryName');
            if (storedCategoryName) {
                setCategoryName(storedCategoryName);

                // Find the corresponding category ID if needed
                const category = allSizes?.find(cat => cat.name === storedCategoryName);
                if (category && category.id) {
                    setSizeid(category.id);
                    setValue("size_chart_category_id", category.id);
                }
            }
        }
    }, [coatid]);
    useEffect(() => {
        const neckValueRaw = watch("ShirtSize"); // Get the selected neck size
        const neckValue = neckValueRaw ? Number(neckValueRaw.split("/")[0]) : null; // Extract valid number

        const isBoyOrder = neckValue !== null && neckValue <= 13; // Boys' order condition

        const shouldAffectSleeve = isBoyOrder && neckValue < 13;

        setDisableSleeve(shouldAffectSleeve); //  Only disable for neck < 13
        setShowSleeve(!shouldAffectSleeve);
    }, [watch("ShirtSize")]);



    // Function to generate neck sizes without duplicates
    const generateNeckSizes = (sizes) => {
        return [...new Set(sizes.map(size => Math.floor(size)))] // Remove duplicates
            .sort((a, b) => a - b) // Sort ascending
            .map(baseSize => {
                if (baseSize >= 10 && baseSize < 20) {
                    return { value: `${baseSize}/${baseSize + 0.5}`, label: `${baseSize}/${baseSize + 0.5}`, baseValue: baseSize }; // 10/10.5, 11/11.5, etc.
                } else if (baseSize >= 20 && baseSize % 2 === 0) {
                    return {
                        value: `${baseSize}/${baseSize + 1}`, label: `${baseSize}/${baseSize + 1}`, baseValue: baseSize  // Store original base number for comparison
                    }; // 20/21, 22/23, 24/25 (Skipping alternate)
                }
                return null;
            })
            .filter(option => option !== null); // Remove null values
    };

    const sleeveSizeMapping = {
        "13/13.5": [30, 32],
        "14/14.5": [30, 32, 34, 36],
        "15/15.5": [30, 32, 34, 36, 38],
        "16/16.5": [30, 32, 34, 36, 38],
        "17/17.5": [30, 32, 34, 36, 38],
        "18/18.5": [30, 32, 34, 36, 38],
        "19/19.5": [32, 34, 36, 38],
        "20/21": [32, 34, 36, 38],
        "22/23": [32, 34, 36, 38],
        "24/25": [34, 36, 38],
        "26/27": [34, 36, 38],
    };

    const handleNeckChange = (selectedOption) => {
        setSelectedNeckSize(selectedOption ? selectedOption.value : null);
        setValue("ShirtSize", selectedOption ? selectedOption.value : ''); // Update form state
    };
    const filteredSleeveOptions = useMemo(() => {
        if (!selectedNeckSize) return [];

        return (sleeveSizeMapping[selectedNeckSize] || []).map(size => ({
            value: size,
            label: `${size}/${size + 1}`,
        }));
    }, [selectedNeckSize]);

    useEffect(() => {
        // Load saved recommendation messages when component mounts
        const savedPantMsg = localStorage.getItem('pantSizeRecommendationMsg');
        const savedShirtMsg = localStorage.getItem('shirtSizeRecommendationMsg');
        const savedVestMsg = localStorage.getItem('vestRecommendationMsg');

        if (savedPantMsg) setSizeRecommendationMsg(savedPantMsg);
        if (savedShirtMsg) setShirtSizeRecommendationMsg(savedShirtMsg);
        if (savedVestMsg) setVestRecommendationMsg(savedVestMsg);
    }, []);

    const checkPantSizeRanges = (selectedValue, fieldType) => {
        // Clear existing message first
        setSizeRecommendationMsg("");

        // Get user input values
        const waist = Number(watch("Waist"));
        const outseam = Number(watch("outseam"));
        const hip = Number(watch("hip"));
        const weight = watch("Weight");

        // Convert height to feet & inches format
        const feet = Math.floor(selectedHeight / 12);
        const inches = selectedHeight % 12;
        const formattedHeight = `${feet}'${inches}"`;
        // Case 1: Coat size is selected - use existing logic
        if (coatid && sizesCategory[0]) {
            const coatSize = coatid;
            const waistMin = sizesCategory[0]?.minWaist;
            const waistMax = sizesCategory[0]?.maxWaist;
            const outseamMin = sizesCategory[0]?.minOutseam;
            const outseamMax = sizesCategory[0]?.maxOutseam;
            const hipMin = sizesCategory[0]?.minHip;
            const hipMax = sizesCategory[0]?.maxHip;

            const isWaistOut = waist && (waist < waistMin || waist > waistMax);
            const isOutseamOut = outseam && (outseam < outseamMin || outseam > outseamMax);
            const isHipOut = hip && (hip < hipMin || hip > hipMax);

            let categoryInitial = categoryName?.charAt(0) || "";
            if (categoryName?.includes("E")) {
                categoryInitial = "XL";
            }
            let msg = `⚠️ For Coat Size ${coatSize}${categoryInitial}: `;
            const parts = [];

            if (isWaistOut) parts.push(`Recommended Waist: ${waistMin}-${waistMax}`);
            if (isOutseamOut) parts.push(`Recommended Outseam: ${outseamMin}-${outseamMax}`);
            if (isHipOut) parts.push(`Recommended Hip: ${hipMin}-${hipMax}`);

            const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
            setSizeRecommendationMsg(finalMsg);
            localStorage.setItem('pantSizeRecommendationMsg', finalMsg);

        }
        // Case 2: No coat size but have valid height and weight
        else if (selectedHeight && weight && !coatid) {
            const isWeightValid = weight !== null && weight !== undefined && !isNaN(weight) && weight !== "";

            const validSizeCharts = sizes
                .flatMap(category => category.size_charts)
                .filter(size =>
                    size.minHeight !== null &&
                    size.maxHeight !== null &&
                    selectedHeight >= size.minHeight &&
                    selectedHeight <= size.maxHeight
                );

            let isWeightInRange = false;
            if (isWeightValid) {
                isWeightInRange = validSizeCharts.some(chart =>
                    (!chart.minWeight || Number(weight) >= chart.minWeight) &&
                    (!chart.maxWeight || Number(weight) <= chart.maxWeight)
                );
            }

            if (isWeightValid && isWeightInRange && validSizeCharts.length > 0) {
                const sizeData = sizes || [];
                if (sizeData.length > 0) {
                    let foundChart = null;

                    for (const category of sizeData) {
                        if (category.size_charts && category.size_charts.length > 0) {
                            foundChart = category.size_charts[0];
                            break;
                        }
                    }

                    if (foundChart) {
                        const waistMin = foundChart.minWaist;
                        const waistMax = foundChart.maxWaist;
                        const outseamMin = foundChart.minOutseam;
                        const outseamMax = foundChart.maxOutseam;
                        const hipMin = foundChart.minHip;
                        const hipMax = foundChart.maxHip;

                        const isWaistOut = waist && (waist < waistMin || waist > waistMax);
                        const isOutseamOut = outseam && (outseam < outseamMin || outseam > outseamMax);
                        const isHipOut = hip && (hip < hipMin || hip > hipMax);

                        const isAllSelected = waist && outseam && hip;

                        // Show message only if all three are selected
                        if (isAllSelected) {
                            let msg = `⚠️ Based on Height (${formattedHeight}) and Weight (${weight}): `;
                            const parts = [];

                            if (isWaistOut) parts.push(`Recommended Waist: ${waistMin}-${waistMax}`);
                            if (isOutseamOut) parts.push(`Recommended Outseam: ${outseamMin}-${outseamMax}`);
                            if (isHipOut) parts.push(`Recommended Hip: ${hipMin}-${hipMax}`);

                            const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
                            setSizeRecommendationMsg(finalMsg);
                            localStorage.setItem('pantSizeRecommendationMsg', finalMsg);

                        } else {
                            let msg = `⚠️ Based on Height (${formattedHeight}) and Weight (${weight}): `;

                            // If only one or two fields selected, show message only for those
                            const parts = [];

                            if (waist && isWaistOut) parts.push(` Recommended Waist: ${waistMin}-${waistMax}`);
                            if (outseam && isOutseamOut) parts.push(` Recommended Outseam:${outseamMin}-${outseamMax}`);
                            if (hip && isHipOut) parts.push(` Recommended Hip: ${hipMin}-${hipMax}`);

                            const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
                            setSizeRecommendationMsg(finalMsg);
                            localStorage.setItem('pantSizeRecommendationMsg', finalMsg);

                        }
                    }
                }
            } else {
                setSizeRecommendationMsg("");
            }
        }


    };



    const checkShirtSizeRanges = (selectedValue, fieldType) => {
        setShirtSizeRecommendationMsg(""); // Clear any existing message

        const neckRaw = watch("ShirtSize");
        const sleeveRaw = watch("Sleeve");
        const neckValue = neckRaw ? Number(neckRaw.split("/")[0]) : null;
        const sleeveValue = sleeveRaw ? Number(sleeveRaw) : null;
        const weight = watch("Weight");


        // Convert height to feet & inches format
        const feet = Math.floor(selectedHeight / 12);
        const inches = selectedHeight % 12;
        const formattedHeight = `${feet}'${inches}"`;

        const isNeckProvided = neckValue !== null && neckRaw !== "";
        const isSleeveProvided = sleeveValue !== null && sleeveRaw !== "";

        const isWeightValid = weight !== null && weight !== undefined && !isNaN(weight) && weight !== "";

        const validSizeCharts = sizes
            .flatMap(category => category.size_charts)
            .filter(size =>
                size.minHeight !== null &&
                size.maxHeight !== null &&
                selectedHeight >= size.minHeight &&
                selectedHeight <= size.maxHeight
            );

        let isWeightInRange = false;
        if (isWeightValid) {
            isWeightInRange = validSizeCharts.some(chart =>
                (!chart.minWeight || Number(weight) >= chart.minWeight) &&
                (!chart.maxWeight || Number(weight) <= chart.maxWeight)
            );
        }

        const isHeightAndWeightValid = selectedHeight && isWeightValid && isWeightInRange;

        // Case 1: If coat ID exists, use existing chart logic
        if (coatid && sizesCategory[0]) {
            const neckMin = sizesCategory[0]?.minNeck;
            const neckMax = sizesCategory[0]?.maxNeck;
            const sleeveMin = sizesCategory[0]?.minShirtSleeve;
            const sleeveMax = sizesCategory[0]?.maxShirtSleeve;

            const isNeckOutOfRange = isNeckProvided && (neckValue < neckMin || neckValue > neckMax);
            const isSleeveOutOfRange = isSleeveProvided && (sleeveValue + 1 < sleeveMin || sleeveValue > sleeveMax);

            let categoryInitial = categoryName?.charAt(0) || "";
            if (categoryName?.includes("E")) {
                categoryInitial = "XL";
            }
            const coatSize = coatid;

            let msg = `⚠️ For Coat Size ${coatSize}${categoryInitial}: `;
            const parts = [];

            if (isNeckProvided && isNeckOutOfRange) {
                parts.push(`Recommended Neck Size: ${neckMin}-${neckMax}`);
            }

            if (isSleeveProvided && isSleeveOutOfRange) {
                parts.push(`Recommended Sleeve Length: ${sleeveMin}-${sleeveMax}`);
            }

            const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
            setShirtSizeRecommendationMsg(finalMsg);
            localStorage.setItem('shirtSizeRecommendationMsg', finalMsg);

        }

        // Case 2: No coat ID but valid height and weight
        else if (!coatid && isHeightAndWeightValid) {
            let foundChart = null;
            for (const category of sizes || []) {
                if (category.size_charts && category.size_charts.length > 0) {
                    foundChart = category.size_charts[0];
                    break;
                }
            }

            if (foundChart) {
                const neckMin = foundChart?.minNeck;
                const neckMax = foundChart?.maxNeck;
                const sleeveMin = foundChart?.minShirtSleeve;
                const sleeveMax = foundChart?.maxShirtSleeve;

                const isNeckOutOfRange = isNeckProvided && (neckValue < neckMin || neckValue > neckMax);
                const isSleeveOutOfRange = isSleeveProvided && (sleeveValue < sleeveMin || sleeveValue > sleeveMax);

                let msg = `⚠️ Based on Height (${formattedHeight}) and Weight (${weight}): `;
                const parts = [];

                if (isNeckProvided && isNeckOutOfRange) {
                    parts.push(`Recommended Neck Size: ${neckMin}-${neckMax}`);
                }

                if (isSleeveProvided && isSleeveOutOfRange) {
                    parts.push(`Recommended Sleeve Length: ${sleeveMin}-${sleeveMax}`);
                }

                const finalMsg = parts.length ? msg + parts.join(", ") + "." : "";
                setShirtSizeRecommendationMsg(finalMsg);
                localStorage.setItem('shirtSizeRecommendationMsg', finalMsg);

            }
        } else {
            setShirtSizeRecommendationMsg("");
        }
    };


    const checkVestSizeRanges = (selectedValue, fieldType) => {
        // Clear any existing message
        setVestRecommendationMsg("");

        const weight = watch("Weight");
        // Convert height to feet & inches format
        const feet = Math.floor(selectedHeight / 12);
        const inches = selectedHeight % 12;
        const formattedHeight = `${feet}'${inches}"`;
        // Case 1: If coat ID exists, use standard chart logic
        if (coatid && sizesCategory[0]) {
            // Validate selected value
            if (!selectedValue || selectedValue.value === undefined) return;

            const selectedVestSize = String(selectedValue.value);
            const recommendedVest = String(sizesCategory[0]?.vestSize || "").trim();
            let categoryInitial = categoryName?.charAt(0) || "";
            if (categoryName?.includes("E")) {
                categoryInitial = "XL";
            }
            const isVestOutOfRange = selectedVestSize !== recommendedVest;

            if (isVestOutOfRange) {
                // setVestRecommendationMsg(
                //     `⚠️ For Coat Size ${coatid}${categoryInitial}: Recommended Vest ${recommendedVest}.`
                // );
                const msg = `⚠️ For Coat Size ${coatid}${categoryInitial}: Recommended Vest ${recommendedVest}.`;
                setVestRecommendationMsg(msg);
                localStorage.setItem('vestRecommendationMsg', msg);
            }

            return; // Exit here so it doesn't run height-weight logic
        }

        // Case 2: No coat size, but height and valid weight present
        if (selectedHeight && weight) {
            const isWeightValid =
                weight !== null && weight !== undefined && !isNaN(weight) && weight !== "";

            const validSizeCharts = sizes
                .flatMap(category => category.size_charts)
                .filter(size =>
                    size.minHeight !== null &&
                    size.maxHeight !== null &&
                    selectedHeight >= size.minHeight &&
                    selectedHeight <= size.maxHeight
                );

            let isWeightInRange = false;
            if (isWeightValid) {
                isWeightInRange = validSizeCharts.some(chart =>
                    (!chart.minWeight || Number(weight) >= chart.minWeight) &&
                    (!chart.maxWeight || Number(weight) <= chart.maxWeight)
                );
            }

            if (isWeightValid && isWeightInRange && validSizeCharts.length > 0) {
                let foundChart = null;

                for (const category of sizes || []) {
                    if (category.size_charts && category.size_charts.length > 0) {
                        foundChart = category.size_charts[0];
                        break;
                    }
                }

                if (foundChart) {
                    const recommendedVest = String(foundChart?.vestSize || "").trim();

                    if (selectedValue?.value && String(selectedValue.value) !== recommendedVest) {
                        // setVestRecommendationMsg(
                        //     `⚠️ Based on Height (${formattedHeight}) and Weight (${weight}): Recommended Vest ${recommendedVest}.`
                        // );
                        const msg = `⚠️ Based on Height (${formattedHeight}) and Weight (${weight}): Recommended Vest ${recommendedVest}.`;
                        setVestRecommendationMsg(msg);
                        localStorage.setItem('vestRecommendationMsg', msg);

                    }
                }
            }
        }
    };

    const onError = (errors) => {
        // Show toast when there are form errors
        toast.error('Please fill the form properly', {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

        // Optional: Log errors to console
        console.log('Form errors:', errors);
    };


    return (
        <Container>
            <div class="nk-content ">
                <div class="container-fluid">
                    <div class="nk-content-inner">
                        <div class="nk-content-body">
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">{location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Weddings Events {(ticket && location.pathname != "/add-order") && `#${ticket}`}</h3></div>

                                </div>
                            </div>

                            <div class="card card-full">
                                <div class="card-inner">
                                    <div class="stepperLeft">
                                        <div className="row">
                                            <div className="col-md-4 brIght">
                                                <section className="section1">
                                                    <header>
                                                        <div className="bead complete"><span><i class="fa-solid fa-check"></i></span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Groom Detail
                                                    </header>
                                                </section>
                                                <section className="section2">
                                                    <header>
                                                        <div className="bead complete"><span><i class="fa-solid fa-check"></i></span></div>{location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Bride Detail
                                                    </header>
                                                </section>
                                                <section className="section2">
                                                    <header>
                                                        <div className="bead current"><span>3</span></div>{location.pathname == "/add-wedding-order" ? "Add" : "Update"} Style Detail
                                                    </header>
                                                </section>
                                                <section>
                                                    <header>
                                                        <div className="bead"><span>4</span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"} Description
                                                    </header>
                                                </section>
                                            </div>

                                            <div className="col-md-8">
                                                <div className="row">
                                                    <div className="d-flex align-items-center justify-content-between w-100 ">
                                                        <h4>{location.pathname == "/add-wedding-order" ? "Add" : "Update"} Style Detail</h4>

                                                    </div></div>
                                                <form onSubmit={handleSubmit(onNext, onError)}>
                                                    <div className="inputCardBox mt-4">
                                                        <div className="row">
                                                            <div className="col-6 col-md-6 mb-3 stateSelect">
                                                                <label>Height <span className="text-red-500">*</span></label>
                                                                <Controller
                                                                    name="Height"
                                                                    control={control}
                                                                    rules={{ required: "Height is required" }}
                                                                    render={({ field }) => (
                                                                        <Select
                                                                            {...field}
                                                                            options={getHeightOptions()}
                                                                            placeholder="Select height"
                                                                            isClearable
                                                                            onChange={(selectedOption) => {
                                                                                if (!selectedOption) {
                                                                                    // Jab height unselect ho to state aur form values reset ho jayein
                                                                                    field.onChange('');
                                                                                    setSelectedHeight("");
                                                                                    setSelectedCoatSize("");
                                                                                    setValue("Weight", "");
                                                                                    setValue("coatsize_chart_id", "");
                                                                                    setValue("Waist", "");
                                                                                    setValue("hip", "");
                                                                                    setValue("outseam", "");
                                                                                    setValue("ShirtSize", "");
                                                                                    setValue("VestColor", "");
                                                                                    setSizeRecommendationMsg("");
                                                                                    setShirtSizeRecommendationMsg("");
                                                                                    setVestRecommendationMsg("");


                                                                                } else {
                                                                                    // Jab height select ho to normal behavior
                                                                                    field.onChange(selectedOption.value);
                                                                                    setSelectedHeight(selectedOption.value);
                                                                                    setSelectedCoatSize("");
                                                                                    setValue("Weight", "");
                                                                                    setValue("coatsize_chart_id", "");
                                                                                }
                                                                            }}
                                                                            value={getHeightOptions().find(option => option.value === field.value) || null}
                                                                            isOptionDisabled={(option) => option.isDisabled}
                                                                        />
                                                                    )}
                                                                />
                                                                {errors.Height && <p className='red'>{errors.Height.message}</p>}
                                                            </div>
                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Weight <small>(  2 or 3 Digit Only )</small> <span className="text-red-500">*</span></label>
                                                                <input class="" type="text" placeholder="Enter weight"
                                                                    {...register("Weight", {
                                                                        required: "Weight is required",
                                                                        pattern: {
                                                                            value: /^[1-9]$|^[1-9][0-9]$|^[1-9][0-9]{2}$/, // This regex ensures 1, 2, or 3 digits (from 1 to 999)
                                                                            message: "Weight must be a maximum of 3 digits"
                                                                        },
                                                                        onChange: () => {
                                                                            // Trigger size recalculation when weight changes
                                                                            // if (selectedHeight || initialValues?.Height || orderForState) {
                                                                            //     size();
                                                                            // }
                                                                        }
                                                                    })}
                                                                />
                                                                {errors.Weight && <p className='red'>{errors.Weight.message}</p>}
                                                            </div>

                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Chest <small>( 3 Digit Only )</small> <span className="text-red-500"></span></label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter chest"
                                                                    {...register("Chest", {
                                                                        required: false,
                                                                        validate: (value) => {
                                                                            if (value) {
                                                                                if (!/^\d{1,2}$/.test(value)) {
                                                                                    return "Chest must be 1-2 digits (1-99)";
                                                                                }
                                                                                const num = parseInt(value, 10);
                                                                                if (num < 1 || num > 99) {
                                                                                    return "Chest must be between 1-99";
                                                                                }
                                                                            }
                                                                            return true;
                                                                        },
                                                                    })}
                                                                />
                                                                {errors.Chest && <p className='red'>{errors.Chest.message}</p>}
                                                            </div>

                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Overarm <small>( 2 Digit ) </small> <span className="text-red-500"></span></label>
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter overarm"
                                                                    {...register("Overarm", {
                                                                        // Make the field optional
                                                                        required: false,
                                                                        // Apply validation only if the field is filled
                                                                        validate: (value) => {
                                                                            if (value && !/^\d{2}$/.test(value)) {
                                                                                return "Overarm must be a 2-digit number";
                                                                            }
                                                                            return true;
                                                                        },
                                                                    })}
                                                                />
                                                                {errors.Overarm && <p className='red'>{errors.Overarm.message}</p>}
                                                            </div>
                                                        </div>


                                                        <div className="col-md-12">
                                                            <div id="accordion" class="accordion">
                                                                <div class="accordion-item">
                                                                    <Link class="accordion-head" data-bs-toggle="collapse" data-bs-target="#accordion-item-1">
                                                                        Coat Style
                                                                        <span class="accordion-icon"></span>
                                                                    </Link>
                                                                    <div className="accordion-body collapse show" id="accordion-item-1" data-bs-parent="#accordion">
                                                                        <div className="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-8 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Coat Style<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="Coat"
                                                                                                control={control}
                                                                                                // rules={{ required: "Coat is required" }}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        // options={options}
                                                                                                        options={sortedOptions}
                                                                                                        placeholder="Select"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                            handleCoatChange(selectedOption);
                                                                                                        }}
                                                                                                        value={options.find(option => option.value === field.value) || null}

                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.Coat && <p className='red'>{errors.Coat.message}</p>}
                                                                                        </div>
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <h6 className="mb-0 mt-1">{Coatstyle?.style ? `#${Coatstyle.style} ` : ''}</h6>
                                                                                            <p className="coatTxtPra"><small>{Coatstyle?.description}</small></p>
                                                                                        </div>

                                                                                        <div >
                                                                                            <a href="" data-bs-toggle="modal" data-bs-target="#alterationsCoatModal"></a>
                                                                                        </div>
                                                                                        <div className="col-12 col-md-6 mb-3">
                                                                                            <label>Coat Size<span className="text-red-500">*</span></label>
                                                                                            <Controller
                                                                                                name="CoatSize"
                                                                                                control={control}
                                                                                                rules={coatSizeValidation}
                                                                                                render={({ field }) => {
                                                                                                    // Get all unique coat sizes from the sizes array
                                                                                                    const uniqueCoatSizes = sizes
                                                                                                        .filter(category => category.size_charts.length > 0)
                                                                                                        .flatMap(category => category.size_charts.map(size => size.coatSize));

                                                                                                    // Filter only categories that have size charts
                                                                                                    const filteredCategories = sizes.filter(category => category.size_charts.length > 0);
                                                                                                    const availableCoatSizes = !selectedHeight
                                                                                                        ? []
                                                                                                        : (AllSize?.coatSizes || []).map(size => ({
                                                                                                            value: size,
                                                                                                            label: size.toString(),
                                                                                                        }));

                                                                                                    // const sortedOptions = [...availableCoatSizes].sort((a, b) => {
                                                                                                    //     if (uniqueCoatSizes.includes(a.value) && !uniqueCoatSizes.includes(b.value)) {
                                                                                                    //         return -1;
                                                                                                    //     }
                                                                                                    //     if (!uniqueCoatSizes.includes(a.value) && uniqueCoatSizes.includes(b.value)) {
                                                                                                    //         return 1;
                                                                                                    //     }
                                                                                                    //     return a.value - b.value;
                                                                                                    // });
                                                                                                    // Get the maximum bold value
                                                                                                    const maxBoldValue = Math.max(...uniqueCoatSizes);

                                                                                                    // Modify your sorting function
                                                                                                    const sortedOptions = [...availableCoatSizes].sort((a, b) => {
                                                                                                        // First prioritize by whether they're bold values
                                                                                                        const aIsBold = uniqueCoatSizes.includes(a.value);
                                                                                                        const bIsBold = uniqueCoatSizes.includes(b.value);

                                                                                                        if (aIsBold !== bIsBold) {
                                                                                                            return aIsBold ? -1 : 1; // Bold values come first
                                                                                                        }

                                                                                                        // For values after the max bold value, put them at the top
                                                                                                        const aIsAfterMaxBold = a.value > maxBoldValue;
                                                                                                        const bIsAfterMaxBold = b.value > maxBoldValue;

                                                                                                        if (aIsAfterMaxBold !== bIsAfterMaxBold) {
                                                                                                            return aIsAfterMaxBold ? -1 : 1; // Values after max bold come next
                                                                                                        }

                                                                                                        // Otherwise sort numerically
                                                                                                        return a.value - b.value;
                                                                                                    });

                                                                                                    // Find the default value in options
                                                                                                    // const defaultValue = sortedOptions.find(opt => opt.value === initialValues.CoatSize) || null;
                                                                                                    const defaultValue = sortedOptions.find(opt => opt.value === (selectedCoatSize || initialValues.CoatSize)) || null;

                                                                                                    return (
                                                                                                        <>
                                                                                                            <Select
                                                                                                                {...field}
                                                                                                                options={sortedOptions}
                                                                                                                placeholder="Select coat size"
                                                                                                                isClearable
                                                                                                                // value={defaultValue || (selectedHeight
                                                                                                                //     ? (sortedOptions.find(option => option.value === selectedCoatSize) || null)
                                                                                                                //     : null)}
                                                                                                                // value={defaultValue || sortedOptions.find(option => option.value === selectedCoatSize) || null}
                                                                                                                value={sortedOptions.find(option => option.value === field.value) || null}


                                                                                                                onChange={(selectedOption) => {
                                                                                                                    if (!selectedOption) {
                                                                                                                        field.onChange(null);
                                                                                                                        setValue("coatsize_chart_id", null);
                                                                                                                        setcoat(null);
                                                                                                                        setMatchedItems([]);
                                                                                                                        setCategoryName('')
                                                                                                                        setTempCoatSize(null);
                                                                                                                        setNonBoldMessage("");
                                                                                                                        localStorage.removeItem('coatid');
                                                                                                                        setSelectedCoatSize(null);
                                                                                                                        setValue("Waist", "");
                                                                                                                        setValue("hip", "");
                                                                                                                        setValue("outseam", "");
                                                                                                                        setValue("ShirtSize", "");
                                                                                                                        setValue("VestColor", "");
                                                                                                                        setSizeRecommendationMsg("");
                                                                                                                        setShirtSizeRecommendationMsg("");
                                                                                                                        setVestRecommendationMsg("");
                                                                                                                        setCoatid(null);

                                                                                                                        if (selectedHeight && weight) {
                                                                                                                            setWaistSizes([]);
                                                                                                                            setHipSizes([]);
                                                                                                                            setoutseamSizes([]);

                                                                                                                        }
                                                                                                                        return;
                                                                                                                    }

                                                                                                                    setSelectedCoatSize(selectedOption.value);
                                                                                                                    const selectedSize = selectedOption.value;
                                                                                                                    const isBold = uniqueCoatSizes.includes(selectedSize);
                                                                                                                    const weightValue = watch("Weight");

                                                                                                                    setValue("coatsize_chart_id", selectedOption.value);
                                                                                                                    setcoat(selectedOption.value);
                                                                                                                    setCoatid(selectedOption.value);
                                                                                                                    setStoprender(true);
                                                                                                                    localStorage.setItem('selectedCoatSize', selectedOption.value);

                                                                                                                    // when a coatSize is selected
                                                                                                                    setSizeRecommendationMsg("");
                                                                                                                    setShirtSizeRecommendationMsg("");
                                                                                                                    setVestRecommendationMsg("");

                                                                                                                    let recommendationMessage = "";
                                                                                                                    if (selectedHeight) {
                                                                                                                        const feet = Math.floor(selectedHeight / 12);
                                                                                                                        const inches = selectedHeight % 12;
                                                                                                                        const formattedHeight = `${feet}'${inches}''`;
                                                                                                                        const sortedBoldSizes = [...uniqueCoatSizes].sort((a, b) => a - b);
                                                                                                                        const firstBoldSize = sortedBoldSizes[0];
                                                                                                                        const lastBoldSize = sortedBoldSizes[sortedBoldSizes.length - 1];

                                                                                                                        const selectedSizeChart = sizes
                                                                                                                            .flatMap(category => category.size_charts)
                                                                                                                            .find(size => size.coatSize === selectedCoatSize);

                                                                                                                        const minWeight = selectedSizeChart?.minWeight || null;
                                                                                                                        const maxWeight = selectedSizeChart?.maxWeight || null;

                                                                                                                        if (weightValue && minWeight !== null && maxWeight !== null) {
                                                                                                                            if (weightValue >= minWeight && weightValue <= maxWeight) {
                                                                                                                                recommendationMessage += ` and weight ${weightValue}`;
                                                                                                                            } else {
                                                                                                                                recommendationMessage += ` but weight ${weightValue} is out of range (${minWeight}-${maxWeight})`;
                                                                                                                            }
                                                                                                                        }
                                                                                                                    }

                                                                                                                    if (!isBold) {
                                                                                                                        setNonBoldMessage(recommendationMessage);
                                                                                                                    } else {
                                                                                                                        if (!recommendationMessage) {
                                                                                                                            setNonBoldMessage("");
                                                                                                                        }
                                                                                                                    }

                                                                                                                    field.onChange(selectedOption.value);
                                                                                                                }}
                                                                                                                formatOptionLabel={(option, { context }) => (
                                                                                                                    <div style={uniqueCoatSizes.includes(option.value) ? { fontWeight: 'bold' } : {}}>
                                                                                                                        {option.label}
                                                                                                                    </div>
                                                                                                                )}
                                                                                                            />
                                                                                                            {errors.CoatSize && <p className='red'>{errors.CoatSize.message}</p>}
                                                                                                            {/* {orderForState === "Boys" && field.value && (
                                                                                                                           <p className="text-blue-600 font-bold mt-2"></p>
                                                                                                                       )} */}

                                                                                                            <div className="col-md-12">
                                                                                                                <div className="d-flex flex-wrap mt-3">
                                                                                                                    {allSizes.map((category, index) => {
                                                                                                                        const isMatchedCategory = MatchedItems.some(matched => matched.id === category.id);
                                                                                                                        const isShortCategory = category.name.length < 3;
                                                                                                                        const isCurrentCategory = category.name === categoryName;
                                                                                                                        const hasData = category.size_charts && category.size_charts.length > 0;

                                                                                                                        return (
                                                                                                                            <div
                                                                                                                                key={index}
                                                                                                                                className={`coatSizeCategorySize px-2 py-1 rounded-lg mx-1 
                               ${hasData ? (isMatchedCategory ? 'bg-green-500 selectedBox' : 'disableSize text-black') : 'bg-gray-300 text-gray-500 cursor-not-allowed'}
                               ${isCurrentCategory ? 'bg-blue-600 text-white border-2 border-blue-700 font-bold transform scale-110 z-10' : ''} 
                               ${isShortCategory && !isCurrentCategory ? 'border-blue-500 border-2' : ''} 
                               ${isCurrentCategory ? "blueSelected" : ""}
                           `}
                                                                                                                                onClick={(hasData && isMatchedCategory) ? () => {
                                                                                                                                    setSizeid(category.id);
                                                                                                                                    setValue("size_chart_category_id", category?.id);
                                                                                                                                    setCategoryName(category.name);
                                                                                                                                    localStorage.setItem('selectedCategoryName', category.name);
                                                                                                                                    setStoprender(false);
                                                                                                                                } : undefined}
                                                                                                                            >
                                                                                                                                {category.name.charAt(0).toUpperCase() === "E" ? "XL" : category.name.charAt(0)}
                                                                                                                            </div>
                                                                                                                        );
                                                                                                                    })}
                                                                                                                    {categoryName && (
                                                                                                                        <p className="text-lg font-bold text-blue-700 mt-3">
                                                                                                                            <strong>Size:</strong> {categoryName}
                                                                                                                        </p>
                                                                                                                    )}
                                                                                                                </div>

                                                                                                                {nonBoldMessage && <p className="text-red-600 font-bold mt-2">{nonBoldMessage}</p>}
                                                                                                                {recommendationMessage && <p className="text-red-600 font-bold mt-2">{recommendationMessage}</p>}

                                                                                                            </div>


                                                                                                        </>
                                                                                                    );
                                                                                                }}
                                                                                            />
                                                                                        </div>




                                                                                        <div className="col-12 col-md-6 mb-3">
                                                                                            <label>Insleeve<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="Insleeve"
                                                                                                control={control}
                                                                                                // rules={insleeveValidation} // Conditional validation
                                                                                                render={({ field }) => {

                                                                                                    const insleeveTimes = [];
                                                                                                    for (let time = 8.0; time <= 20.5; time += 0.5) {
                                                                                                        insleeveTimes.push({
                                                                                                            value: time.toString(),
                                                                                                            label: time.toString(),
                                                                                                        });
                                                                                                    }
                                                                                                    // Manually add "14.25" if it's missing
                                                                                                    if (!insleeveTimes.some(option => option.value === "14.25")) {
                                                                                                        insleeveTimes.push({ value: "14.25", label: "14.25" });
                                                                                                    }


                                                                                                    return (
                                                                                                        <Select
                                                                                                            {...field}
                                                                                                            options={insleeveTimes}
                                                                                                            placeholder="Select"
                                                                                                            isClearable
                                                                                                            onChange={(selectedOption) => {
                                                                                                                field.onChange(selectedOption ? selectedOption.value : '');


                                                                                                                if (!selectedOption) {

                                                                                                                    setdefaultsize(null)

                                                                                                                    return;
                                                                                                                }
                                                                                                                if (selectedOption && selectedOption.value !== defaultsize) {
                                                                                                                    const modalTrigger = document.querySelector('[data-bs-target="#alterationsCoatModal"]');
                                                                                                                    if (modalTrigger) {
                                                                                                                        modalTrigger.click();
                                                                                                                    }
                                                                                                                }
                                                                                                            }}
                                                                                                            value={field.value ? insleeveTimes.find(option => option.value === field.value) : ''}
                                                                                                        // value={field.value ? insleeveTimes.find(option => option.value === field.value) : defaultValue}

                                                                                                        />
                                                                                                    );
                                                                                                }}
                                                                                            />
                                                                                            {errors.Insleeve && <p className='red'>{errors.Insleeve.message}</p>}

                                                                                            {
                                                                                                defaultsize && <p className="sleeveTxt"><small>Sleeve alterations: $6.00/coat, except default size {defaultsize}.</small></p>

                                                                                            }
                                                                                        </div>

                                                                                    </div >
                                                                                </div >

                                                                                <div className="col-md-4 addStyleMobileImg">
                                                                                    {Coatstyle?.image ? (
                                                                                        <Image src={`${ImageUrl}${Coatstyle?.image}`} className="noSelectCoatImg" alt="" />
                                                                                    ) : (
                                                                                        <img src="/assets/images/no-photo.png" className="selectCoatImg" alt="" />
                                                                                    )}
                                                                                </div>
                                                                            </div >
                                                                        </div >
                                                                    </div >
                                                                </div>


                                                                <div className="accordion-item">
                                                                    <Link className="accordion-head collapsed" data-bs-toggle="collapse" data-bs-target="#accordion-item-2">
                                                                        Pant Style
                                                                        <span className="accordion-icon"></span>
                                                                    </Link>
                                                                    <div className="accordion-body collapse" id="accordion-item-2" data-bs-parent="#accordion">
                                                                        <div className="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-8 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        {/* Pant Style Field */}
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Pant Style<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="Pant"
                                                                                                control={control}
                                                                                                // rules={{ required: "Pant is required" }}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={sortedPants.map(item => ({
                                                                                                            value: `${item.style}`, // Combined value
                                                                                                            label: `${item.style} ${item.description}` // Combined label
                                                                                                        }))}
                                                                                                        placeholder="Select"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            const selectedValue = selectedOption ? selectedOption.value : '';
                                                                                                            field.onChange(selectedValue); // Update form value
                                                                                                            const syntheticEvent = { target: { value: selectedValue } };
                                                                                                            handlePaintChange(syntheticEvent); // Trigger change handler
                                                                                                        }}
                                                                                                        value={sortedPants.map(item => ({
                                                                                                            value: `${item.style}`,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        })).find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.Pant && <p className='red'>{errors.Pant.message}</p>}
                                                                                        </div>

                                                                                        {/* Display Pant Style Details */}
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <h6 className="mb-0 mt-1">{Pantstyle?.style ? `#${Pantstyle.style}` : ''}</h6>
                                                                                            <p className="coatTxtPra"><small>{Pantstyle?.description}</small></p>
                                                                                        </div>

                                                                                        {/* Waist Field */}
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Waist <span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="Waist"
                                                                                                control={control}
                                                                                                rules={{ required: pantStyleSelected ? "Waist is required" : false }}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={[
                                                                                                            { value: 'category', label: categoryName, isDisabled: true },
                                                                                                            ...(AllSize?.waistSizes || []).map(size => ({
                                                                                                                value: size.toString(), // Ensure consistent string values
                                                                                                                label: size.toString(),
                                                                                                            })),
                                                                                                        ]}
                                                                                                        placeholder="Select Waist Size"
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            const selectedValue = selectedOption ? selectedOption.value : '';
                                                                                                            field.onChange(selectedValue);
                                                                                                            if (!selectedValue) {
                                                                                                                setSizeRecommendationMsg("");
                                                                                                                localStorage.removeItem('pantSizeRecommendationMsg');
                                                                                                                return;
                                                                                                            }
                                                                                                            checkPantSizeRanges(selectedValue, "Waist");
                                                                                                        }}
                                                                                                        value={
                                                                                                            field.value
                                                                                                                ? {
                                                                                                                    value: field.value,
                                                                                                                    label: field.value.toString(),
                                                                                                                    // isDisabled: false // Ensure the value can be selected
                                                                                                                }
                                                                                                                : null
                                                                                                        }


                                                                                                        formatOptionLabel={(option, { context }) => (
                                                                                                            <div style={waistSizes.includes(Number(option.value)) ? { fontWeight: 'bold' } : {}}>
                                                                                                                {option.label}
                                                                                                            </div>
                                                                                                        )}

                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {pantStyleSelected && errors.Waist && <p className='red'>{errors.Waist.message}</p>}
                                                                                        </div>

                                                                                        {/* Hip Field */}
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Hip<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="hip"
                                                                                                control={control}
                                                                                                rules={{ required: false }}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={[
                                                                                                            { value: 'category', label: categoryName, isDisabled: true },
                                                                                                            ...(AllSize?.hipSizes || []).map(size => ({
                                                                                                                value: size.toString(), // Ensure consistent string values
                                                                                                                label: size.toString(),
                                                                                                            })),
                                                                                                        ]}
                                                                                                        placeholder="Select Hip Size"
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            const selectedValue = selectedOption ? selectedOption.value : '';
                                                                                                            field.onChange(selectedValue);
                                                                                                            if (!selectedValue) {
                                                                                                                setSizeRecommendationMsg("");
                                                                                                                localStorage.removeItem('pantSizeRecommendationMsg');
                                                                                                                return;
                                                                                                            }
                                                                                                            checkPantSizeRanges(selectedValue, "Hip");
                                                                                                        }}
                                                                                                        value={
                                                                                                            field.value
                                                                                                                ? {
                                                                                                                    value: field.value,
                                                                                                                    label: field.value.toString(),
                                                                                                                    // This ensures the value exists in options
                                                                                                                    isDisabled: false
                                                                                                                }
                                                                                                                : null
                                                                                                        }

                                                                                                        formatOptionLabel={(option, { context }) => (
                                                                                                            <div style={HipSizes.includes(Number(option.value)) ? { fontWeight: 'bold' } : {}}>
                                                                                                                {option.label}
                                                                                                            </div>
                                                                                                        )}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {pantStyleSelected && errors.hip && <p className='red'>{errors.hip.message}</p>}
                                                                                        </div>


                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Outseam<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="outseam"
                                                                                                control={control}
                                                                                                rules={{ required: pantStyleSelected ? "Outseam is required" : false }}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={[
                                                                                                            { value: 'category', label: categoryName, isDisabled: true },
                                                                                                            ...(AllSize?.outseamSizes || []).map(size => ({
                                                                                                                value: size.toString(), // Ensure consistent string values
                                                                                                                label: size.toString(),
                                                                                                            })),
                                                                                                        ]}
                                                                                                        placeholder="Select Outseam Size"
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            const selectedValue = selectedOption ? selectedOption.value : '';
                                                                                                            field.onChange(selectedValue);
                                                                                                            if (!selectedValue) {
                                                                                                                setSizeRecommendationMsg("");
                                                                                                                localStorage.removeItem('pantSizeRecommendationMsg');
                                                                                                                return;
                                                                                                            }
                                                                                                            checkPantSizeRanges(selectedValue, "Outseam");
                                                                                                        }}
                                                                                                        value={
                                                                                                            field.value
                                                                                                                ? {
                                                                                                                    value: field.value,
                                                                                                                    label: field.value.toString(),
                                                                                                                    // isDisabled: false // Important for selected value to appear in dropdown
                                                                                                                }
                                                                                                                : null
                                                                                                        }
                                                                                                        formatOptionLabel={(option, { context }) => (
                                                                                                            <div style={outseamSizes.includes(Number(option.value)) ? { fontWeight: 'bold' } : {}}>
                                                                                                                {option.label}
                                                                                                            </div>
                                                                                                        )}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {pantStyleSelected && errors.outseam && <p className='red'>{errors.outseam.message}</p>}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4 addStyleMobileImg">
                                                                                    {Pantstyle?.image ? (
                                                                                        <Image src={`${ImageUrl}${Pantstyle?.image}`} className="noSelectCoatImg" alt="" />
                                                                                    ) : (
                                                                                        <img src="/assets/images/no-photo.png" className="selectCoatImg" alt="" />
                                                                                    )}
                                                                                </div>
                                                                                {/* Size Recommendation Message */}
                                                                                {selectedHeight && sizeRecommendationMsg && (
                                                                                    <div className="col-12 mb-3">
                                                                                        <p >{sizeRecommendationMsg}</p>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="accordion-item">
                                                                    <Link class="accordion-head collapsed" data-bs-toggle="collapse" data-bs-target="#accordion-item-3">
                                                                        Shirt Style
                                                                        <span class="accordion-icon"></span>
                                                                    </Link>
                                                                    <div class="accordion-body collapse" id="accordion-item-3" data-bs-parent="#accordion">
                                                                        <div class="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-8 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Shirt Style<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="Shirt"
                                                                                                control={control}
                                                                                                // rules={{ required: "Shirt is required" }}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={sortedShirts.map(item => ({
                                                                                                            value: `${item.style}`, // Combined value
                                                                                                            label: `${item.style} ${item.description}` // Combined label
                                                                                                        }))}
                                                                                                        placeholder="Select"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            const selectedValue = selectedOption ? selectedOption.value : '';
                                                                                                            field.onChange(selectedValue); // Update react-hook-form value

                                                                                                            // Call custom handler with synthetic event
                                                                                                            const syntheticEvent = { target: { value: selectedValue } };
                                                                                                            handleShirtChange(syntheticEvent);
                                                                                                        }}
                                                                                                        value={sortedShirts.map(item => ({
                                                                                                            value: `${item.style}`,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        })).find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.Shirt && <p className='red'>{errors.Shirt.message}</p>}
                                                                                        </div>


                                                                                        <div className="col-md-6 mb-3">
                                                                                            <h6 className="mb-0 mt-1">{shirtstyleData?.style ? `#${shirtstyleData?.style}` : ''}</h6>
                                                                                            <p className="coatTxtPra"><small>{shirtstyleData?.description}</small></p>

                                                                                            {shirtSize && (
                                                                                                <p className="coatTxtPra">
                                                                                                    <small><strong style={{ fontSize: "16px" }}>Shirt Size:</strong> {shirtSize}</small>
                                                                                                </p>
                                                                                            )}
                                                                                        </div>


                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Neck<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="ShirtSize"
                                                                                                control={control}
                                                                                                rules={{ required: shirtStyleSelected ? "Neck size is required" : false }}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}

                                                                                                        options={generateNeckSizes(AllSize?.neckSizes || [])}

                                                                                                        placeholder="Select Neck Size"
                                                                                                        isClearable
                                                                                                        // onChange={(selectedOption) => {
                                                                                                        //     console.log("Selec  ted Option:", selectedOption);

                                                                                                        //     handleNeckChange(selectedOption);
                                                                                                        //     field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                        //     checkShirtSizeRanges(selectedOption, "ShirtSize")

                                                                                                        // }}
                                                                                                        onChange={(selectedOption) => {
                                                                                                            const selectedValue = selectedOption ? selectedOption.value : '';

                                                                                                            field.onChange(selectedValue);
                                                                                                            handleNeckChange(selectedOption);

                                                                                                            if (!selectedValue) {
                                                                                                                setShirtSizeRecommendationMsg("");
                                                                                                                localStorage.removeItem('shirtSizeRecommendationMsg');
                                                                                                                return;
                                                                                                            }

                                                                                                            checkShirtSizeRanges(selectedOption, "ShirtSize");
                                                                                                        }}

                                                                                                        // value={
                                                                                                        //     (AllSize?.neckSizes || [])
                                                                                                        //         .map(size => ({
                                                                                                        //             value: size,
                                                                                                        //             label: size.toString(),
                                                                                                        //         }))
                                                                                                        //         .find(option => option.value === field.value) || null
                                                                                                        // }
                                                                                                        value={field.value ? { value: field.value, label: field.value } : null} // Ensure correct display

                                                                                                        formatOptionLabel={(option, { context }) => (
                                                                                                            <div style={NeckSizes.includes(option.baseValue) ? { fontWeight: 'bold' } : {}}>
                                                                                                                {option.label}
                                                                                                            </div>
                                                                                                        )}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.ShirtSize && <p className='red'>{errors.ShirtSize.message}</p>}
                                                                                        </div>

                                                                                        <div className="col-6 col-md-6 mb-3">
                                                                                            {showSleeve && (
                                                                                                <>
                                                                                                    <label>Sleeve<span className="text-red-500"></span></label>
                                                                                                    <Controller
                                                                                                        name="Sleeve"
                                                                                                        control={control}
                                                                                                        // rules={{ required: shirtStyleSelected ? "Sleeve is required" : "" }}
                                                                                                        rules={{
                                                                                                            required: !disableSleeve && shirtStyleSelected ? "Sleeve is required" : false
                                                                                                        }}
                                                                                                        render={({ field }) => (
                                                                                                            <Select
                                                                                                                {...field}

                                                                                                                options={filteredSleeveOptions}
                                                                                                                placeholder="Select Sleeve Size"
                                                                                                                isClearable
                                                                                                                isDisabled={disableSleeve}

                                                                                                                onChange={(selectedOption) => {
                                                                                                                    checkShirtSizeRanges(selectedOption, "Sleeve")
                                                                                                                    field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                    checkShirtSizeRanges(selectedOption, "Sleeve");

                                                                                                                }}

                                                                                                                value={
                                                                                                                    field.value ?
                                                                                                                        {
                                                                                                                            value: Number(field.value),
                                                                                                                            label: `${Number(field.value)}/${Number(field.value) + 1}`,
                                                                                                                            // originalValue: Number(field.value)
                                                                                                                        } : null
                                                                                                                }

                                                                                                                formatOptionLabel={(option) => (
                                                                                                                    <div style={option.value % 2 === 0 ? { fontWeight: 'bold' } : {}}>
                                                                                                                        {option.label}
                                                                                                                    </div>
                                                                                                                )}

                                                                                                            />
                                                                                                        )}
                                                                                                    />
                                                                                                    {errors.Sleeve && <p className='red'>{errors.Sleeve.message}</p>}</>)}
                                                                                        </div>

                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4 addStyleMobileImg">
                                                                                    {/* <img src="assets/images/profile.png" className="selectCoatImg" alt="" /> */}
                                                                                    {
                                                                                        shirtstyleData?.image ? <Image src={`${ImageUrl}${shirtstyleData?.image}`} className="noSelectCoatImg" alt="" />
                                                                                            : <img src="/assets/images/no-photo.png" className="selectCoatImg" alt />

                                                                                    }
                                                                                    {/* <img src="assets/images/no-photo.png" className="noSelectCoatImg" alt="" /> */}
                                                                                </div>
                                                                                {selectedHeight && shirtSizeRecommendationMsg && (
                                                                                    <div className="col-12 mb-3">
                                                                                        <p >{shirtSizeRecommendationMsg}</p>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="accordion-item">
                                                                    <Link class="accordion-head collapsed" data-bs-toggle="collapse" data-bs-target="#accordion-item-4">
                                                                        Vest Style
                                                                        <span class="accordion-icon"></span>
                                                                    </Link>
                                                                    <div class="accordion-body collapse" id="accordion-item-4" data-bs-parent="#accordion">
                                                                        <div class="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-12 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-8 mb-3">
                                                                                            <div className="row">
                                                                                                <div className="col-md-6 mb-3">
                                                                                                    <label>Vest Style <span className="text-red-500"></span></label>
                                                                                                    <Controller
                                                                                                        name="Vest"
                                                                                                        control={control}
                                                                                                        render={({ field }) => (
                                                                                                            <Select
                                                                                                                {...field}
                                                                                                                options={sortedVest.map(item => ({
                                                                                                                    value: item.style,
                                                                                                                    label: `${item.style} ${item.description}`
                                                                                                                }))}
                                                                                                                placeholder="Select"
                                                                                                                components={customComponents}
                                                                                                                isClearable
                                                                                                                onChange={(selectedOption) => {
                                                                                                                    // Update react-hook-form value
                                                                                                                    field.onChange(selectedOption ? selectedOption.value : '');

                                                                                                                    // Call custom handler with synthetic event
                                                                                                                    const syntheticEvent = { target: { value: selectedOption ? selectedOption.value : '' } };
                                                                                                                    handleVestChange(syntheticEvent);

                                                                                                                }}
                                                                                                                value={Vest.map(item => ({
                                                                                                                    value: item.style,
                                                                                                                    label: `${item.style} ${item.description}`
                                                                                                                })).find(option => option.value === field.value) || null}
                                                                                                            />
                                                                                                        )}
                                                                                                    />
                                                                                                    {errors.Vest && <p className='red'>{errors.Vest.message}</p>}
                                                                                                </div>

                                                                                                <div className="col-md-6 mb-3">
                                                                                                    <h6 className="mb-0 mt-1">{Veststyle?.style ? `#${Veststyle?.style}` : ''}</h6>
                                                                                                    <p className="coatTxtPra"><small>{Veststyle?.description}</small></p>
                                                                                                </div>
                                                                                                <div className="col-md-6 mb-3">
                                                                                                    <label>Vest Size<span className="text-red-500"></span></label>
                                                                                                    <Controller
                                                                                                        name="VestColor"
                                                                                                        control={control}
                                                                                                        rules={{ required: selectedVestStyle ? "Vest size is required" : false }}
                                                                                                        render={({ field }) => {
                                                                                                            // Get unique sizes from the categories
                                                                                                            const uniqueSizes = sizes
                                                                                                                .filter(category => category.size_charts.length > 0)
                                                                                                                .flatMap(category => [
                                                                                                                    ...new Set(category.size_charts.map(size => size.vestSize))
                                                                                                                ]);

                                                                                                            // Transform AllSize.vestSizes into options for the Select component
                                                                                                            // const vestSizeOptions = (AllSize?.vestSizes || []).map(size => ({
                                                                                                            //     value: size,
                                                                                                            //     label: size.toString(), // Ensure label is a string
                                                                                                            // }));


                                                                                                            // Filter only categories that have size charts
                                                                                                            const filteredCategories = sizes.filter(category => category.size_charts.length > 0);

                                                                                                            // Get available coat sizes from AllSize
                                                                                                            const availableCoatSizes = (AllSize?.vestSizes || []).map(size => ({
                                                                                                                value: size,
                                                                                                                label: size.toString(),
                                                                                                            }));

                                                                                                            // Create options grouped by category
                                                                                                            const vestSizeOptions = filteredCategories.map(category => ({
                                                                                                                label: category.name, // Category name as group label
                                                                                                                options: availableCoatSizes
                                                                                                            })).filter(group => group.options.length > 0);

                                                                                                            return (
                                                                                                                <Select
                                                                                                                    {...field}
                                                                                                                    options={availableCoatSizes}
                                                                                                                    placeholder="Select vest size"
                                                                                                                    isClearable
                                                                                                                    // onChange={(selectedOption) => {

                                                                                                                    //     field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                    //     checkVestSizeRanges(selectedOption, "Vest")
                                                                                                                    // }}
                                                                                                                    onChange={(selectedOption) => {
                                                                                                                        const selectedValue = selectedOption ? selectedOption.value : '';

                                                                                                                        field.onChange(selectedValue);

                                                                                                                        if (!selectedValue) {
                                                                                                                            setVestRecommendationMsg("");
                                                                                                                            localStorage.removeItem('vestRecommendationMsg');
                                                                                                                            return;
                                                                                                                        }

                                                                                                                        checkVestSizeRanges(selectedOption, "Vest");
                                                                                                                    }}

                                                                                                                    // value={
                                                                                                                    //     vestSizeOptions.find(option => option.value === field.value) || null
                                                                                                                    // }
                                                                                                                    value={availableCoatSizes.find(option => option.value === field.value) || null}

                                                                                                                    formatOptionLabel={(option, { context }) => (
                                                                                                                        <div style={uniqueSizes.includes(option.value) ? { fontWeight: 'bold' } : {}}>
                                                                                                                            {option.label}
                                                                                                                        </div>
                                                                                                                    )}
                                                                                                                />
                                                                                                            );
                                                                                                        }}
                                                                                                    />
                                                                                                    {errors.VestColor && <p className='red'>{errors.VestColor.message}</p>}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        <div className="col-md-4 addStyleMobileImg">
                                                                                            {
                                                                                                Veststyle?.image ? <Image src={`${ImageUrl}${Veststyle?.image}`} className="noSelectCoatImg" alt="" />
                                                                                                    : <img src="/assets/images/no-photo.png" className="selectCoatImg" alt />

                                                                                            }

                                                                                            {/* <img src="assets/images/profile.png" className="selectCoatImg" alt="" /> */}
                                                                                        </div>

                                                                                    </div>

                                                                                    {/* <div className="col-md-6 mb-3">
                                                                                                       <label>Vest Size<span className="text-red-500">*</span></label>
                                                                                                       <Controller
                                                                                                           name="VestColor"
                                                                                                           control={control}
                                                                                                           rules={{ required: selectedVestStyle ? "Vest size is required" : false }}
                                                                                                           render={({ field }) => {
                                                                                                               // Create grouped options for React Select with duplicate removal
                                                                                                               const groupedOptions = sizes
                                                                                                                   .filter(category => category.size_charts.length > 0)
                                                                                                                   .map(category => {
                                                                                                                       // Get unique sizes for this category
                                                                                                                       const uniqueSizes = [...new Set(
                                                                                                                           category.size_charts.map(size => size.vestSize)
                                                                                                                       )];
       
                                                                                                                       // Create options with unique sizes only
                                                                                                                       return {
                                                                                                                           label: category.name,
                                                                                                                           options: uniqueSizes.map(size => ({
                                                                                                                               value: size,
                                                                                                                               label: size
                                                                                                                           }))
                                                                                                                       };
                                                                                                                   });
       
                                                                                                               return (
                                                                                                                   <Select
                                                                                                                       {...field}
                                                                                                                       options={groupedOptions}
                                                                                                                       placeholder="Select vest size"
                                                                                                                       onChange={(selectedOption) => {
                                                                                                                           field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                       }}
                                                                                                                       value={
                                                                                                                           // Find the selected option in the nested structure
                                                                                                                           groupedOptions.flatMap(group => group.options)
                                                                                                                               .find(option => option.value === field.value) || null
                                                                                                                       }
                                                                                                                   />
                                                                                                               );
                                                                                                           }}
                                                                                                       />
                                                                                                       {errors.VestColor && <p className='red'>{errors.VestColor.message}</p>}
                                                                                                   </div> */}


                                                                                    {selectedHeight && vestRecommendationMsg && (
                                                                                        <div className="col-12 mb-3">
                                                                                            <p >{vestRecommendationMsg}</p>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>


                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="accordion-item">
                                                                    <Link className="accordion-head collapsed" data-bs-toggle="collapse" data-bs-target="#accordion-item-5">
                                                                        Tie, Pocket, Jewelry Style
                                                                        <span className="accordion-icon"></span>
                                                                    </Link>
                                                                    <div className="accordion-body collapse" id="accordion-item-5" data-bs-parent="#accordion">
                                                                        <div className="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-12 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Tie <span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="Tie"
                                                                                                control={control}
                                                                                                // rules={{ required: "Tie is required" }}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={sortedTie.map(item => ({
                                                                                                            value: item.style,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        }))}
                                                                                                        placeholder="Select tie"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                            const syntheticEvent = { target: { value: selectedOption ? selectedOption.value : '' } };
                                                                                                            handleTie(syntheticEvent);
                                                                                                        }}
                                                                                                        value={Tie.map(item => ({
                                                                                                            value: item.style,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        })).find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.Tie && <p className='red'>{errors.Tie.message}</p>}
                                                                                        </div>

                                                                                        <div className="col-md-4 mb-3 " >
                                                                                            <label class="d-block" >Ordered For</label>


                                                                                            <ul className="custom-control-group">
                                                                                                <li>
                                                                                                    <div className="custom-control custom-control-sm custom-radio custom-control-pro">
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            className="custom-control-input"
                                                                                                            name="btnRadio"
                                                                                                            id="btnRadio1"
                                                                                                            value="Men"
                                                                                                            {...register("order_for")}
                                                                                                            checked={orderForState == "Men"}
                                                                                                            onChange={(e) => {
                                                                                                                setOrderForState(e.target.value);
                                                                                                            }}
                                                                                                        // setValue("Height", ""); setSelectedHeight(''); 
                                                                                                        />
                                                                                                        <label className="custom-control-label" htmlFor="btnRadio1">Men</label>
                                                                                                    </div>
                                                                                                </li>
                                                                                                <li>
                                                                                                    <div className="custom-control custom-control-sm custom-radio custom-control-pro">
                                                                                                        <input
                                                                                                            type="radio"
                                                                                                            className="custom-control-input"
                                                                                                            name="btnRadio"
                                                                                                            id="btnRadio2"
                                                                                                            value="Boys"
                                                                                                            {...register("order_for")}
                                                                                                            checked={orderForState == "Boys"}
                                                                                                            onChange={(e) => {
                                                                                                                setOrderForState(e.target.value);

                                                                                                            }}
                                                                                                        />
                                                                                                        <label className="custom-control-label" htmlFor="btnRadio2">Boy</label>
                                                                                                    </div>
                                                                                                </li>
                                                                                            </ul>


                                                                                        </div>

                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Pocket Square <span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="Pocket"
                                                                                                control={control}
                                                                                                // rules={{ required: "Pocket is required" }}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={sortedPocketSquare.map(item => ({
                                                                                                            value: `${item.style}`,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        }))}
                                                                                                        placeholder="Select pocket square"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                            const syntheticEvent = { target: { value: selectedOption ? selectedOption.value : '' } };
                                                                                                            handlePocket(syntheticEvent);
                                                                                                        }}
                                                                                                        value={Pocket.map(item => ({
                                                                                                            value: `${item.style}`,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        })).find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.Pocket && <p className='red'>{errors.Pocket.message}</p>}
                                                                                        </div>

                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Jewelry<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="Jewelry"
                                                                                                control={control}
                                                                                                // rules={{ required: "Jewelry is required" }}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={sortedJewelry.map(item => ({
                                                                                                            value: item.style,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        }))}
                                                                                                        placeholder="Select jewelry"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                            const syntheticEvent = { target: { value: selectedOption ? selectedOption.value : '' } };

                                                                                                            handlejwellaryChange(syntheticEvent);

                                                                                                        }}
                                                                                                        value={Jewelry.map(item => ({
                                                                                                            value: item.style,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        })).find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.Jewelry && <p className='red'>{errors.Jewelry.message}</p>}
                                                                                        </div>

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="accordion-item">
                                                                    <Link className="accordion-head collapsed" data-bs-toggle="collapse" data-bs-target="#accordion-item-6">
                                                                        Shoes Style
                                                                        <span className="accordion-icon"></span>
                                                                    </Link>
                                                                    <div className="accordion-body collapse" id="accordion-item-6" data-bs-parent="#accordion">
                                                                        <div className="accordion-inner">
                                                                            <div className="row">
                                                                                <div className="col-md-12 p-0 stateSelect">
                                                                                    <div className="row">
                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label> Shoes Style <span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="Shoes"
                                                                                                control={control}
                                                                                                rules={{ required: selectedShoesStyle ? "Shoes is required" : false }}
                                                                                                // rules={{ required: selectedShoesStyle ? "Shoes is required" : false }}

                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}
                                                                                                        options={sortedShoes.map(item => ({
                                                                                                            value: `${item.style}`,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        }))}
                                                                                                        placeholder="Select shoes"
                                                                                                        components={customComponents}
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            // Update react-hook-form value
                                                                                                            field.onChange(selectedOption ? selectedOption.value : '');

                                                                                                            // Call custom handler with synthetic event
                                                                                                            const syntheticEvent = { target: { value: selectedOption ? selectedOption.value : '' } };
                                                                                                            handleShoes(syntheticEvent);
                                                                                                        }}
                                                                                                        value={Shoes.map(item => ({
                                                                                                            value: `${item.style}`,
                                                                                                            label: `${item.style} ${item.description}`
                                                                                                        })).find(option => option.value === field.value) || null}
                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.Shoes && <p className='red'>{errors.Shoes.message}</p>}
                                                                                        </div>

                                                                                        <div className="col-md-6 mb-3">
                                                                                            <label>Shoes Size<span className="text-red-500"></span></label>
                                                                                            <Controller
                                                                                                name="ShoesSize"
                                                                                                control={control}
                                                                                                rules={{
                                                                                                    required: watch("Shoes") ? "Shoes Size is required" : false, // Only required when Shoes is selected
                                                                                                }}
                                                                                                render={({ field }) => (
                                                                                                    <Select
                                                                                                        {...field}

                                                                                                        options={[
                                                                                                            ...ShoeSizes.map(size => ({
                                                                                                                value: size,
                                                                                                                label: size // Highlight Boys' sizes (you can style this with CSS instead)
                                                                                                            })),
                                                                                                            // ...mensShoeSizes.map(size => ({
                                                                                                            //     value: size,
                                                                                                            //     label: size
                                                                                                            // }))
                                                                                                        ]}


                                                                                                        placeholder="Select size"
                                                                                                        isClearable
                                                                                                        onChange={(selectedOption) => {
                                                                                                            field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                        }}

                                                                                                        value={
                                                                                                            // (orderForState === "Boys" ? boysShoeSizes : mensShoeSizes)
                                                                                                            ShoeSizes.map(size => ({
                                                                                                                value: size,
                                                                                                                label: size
                                                                                                            }))
                                                                                                                .find(option => option.value === field.value) || null
                                                                                                        }

                                                                                                    // formatOptionLabel={(option) => (
                                                                                                    //     <div style={uniqueShoeSizes.includes(option.value) ? { fontWeight: "bold" } : {}}>
                                                                                                    //         {option.label}
                                                                                                    //     </div>
                                                                                                    // )}

                                                                                                    />
                                                                                                )}
                                                                                            />
                                                                                            {errors.ShoesSize && <p className='red'>{errors.ShoesSize.message}</p>}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-12">
                                                            <div className="row align-items-center">
                                                                <div className="col-md-6 mb-3">
                                                                    <label>Rental Weeks <span className="text-red-500">*</span></label>
                                                                    <select     {...register("Rentalterm")}
                                                                    >
                                                                        <option value={""}>Select week</option>
                                                                        <option value={"1 week"}>1 week</option>
                                                                        <option value={"2 week"}>2 week</option>
                                                                        <option value={"3 week"}>3 week</option>
                                                                        <option value={"3 week"}>4 week</option>


                                                                    </select>
                                                                    {errors.Rentalterm && <p className='red'>{errors.Rentalterm.message}</p>}
                                                                </div>


                                                            </div>

                                                            <div className="row">
                                                                <div class="col-md-12 mt-3">
                                                                    <a className="backBtnWedding" style={{ cursor: "pointer" }} onClick={handleBack}>Back</a>
                                                                    <button
                                                                        type="submit"
                                                                        className="addBtnCustomer"
                                                                        onClick={() => {
                                                                            // Save the current state values to localStorage
                                                                            localStorage.setItem('coatid', coatid);
                                                                            localStorage.setItem('size', sizeid);

                                                                            // Optionally, you can perform additional actions here
                                                                        }}
                                                                    >
                                                                        Continue
                                                                    </button>                                                                    </div>
                                                                {/* {/ <a href="" data-bs-toggle="modal" data-bs-target="#itemSuggestionModal">item Suggestion Modal</a > /} */}


                                                            </div>
                                                        </div>
                                                    </div >
                                                </form >
                                            </div >
                                        </div >
                                    </div >
                                </div >
                            </div >
                        </div >
                    </div >
                </div >
            </div >






            <div class="modal fade" tabindex="-1" id="itemSuggestionModal">
                <div class="modal-dialog itemSuggetionTabs" role="document">
                    <div class="modal-content">
                        <div class="modal-header brNoneBottom">
                            <h5 class="modal-title">Items Suggestion </h5>
                            <a href="" class="addModalButton">Add</a>

                            {/* <a href="#" class="close" data-bs-dismiss="modal" aria-label="Close">
                                               <em class="icon ni ni-cross-c"></em>
                                           </a> */}
                        </div>

                        <div class="modal-body itemSuggTabSColor">
                            <ul class="nav nav-tabs mt-n3">
                                <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" href="#tabItem1">Coat</a></li>
                                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tabItem2">Pants</a></li>
                                <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" href="#tabItem3">Shirt</a></li>
                            </ul>

                            <div class="tab-content">

                                <div class="tab-pane active" id="tabItem1">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="leftImageItem">
                                                <img src="assets/images/prom-ordereview.png" alt="" />
                                                <div class="contentItemSugge">
                                                    <h4>David Major | Suit</h4>
                                                    <p>Light Gray Stretch Material</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-md-12">
                                            <div class="table-responsive">
                                                <table class="table table-bordered table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Size</th>
                                                            <th scope="col">Chest</th>
                                                            <th scope="col">Side Length</th>
                                                            <th scope="col">Sleeve</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>S</td>
                                                            <td>36-38</td>
                                                            <td>26</td>
                                                            <td>8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>M</td>
                                                            <td>38-40</td>
                                                            <td>27</td>
                                                            <td>8.5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>L</td>
                                                            <td>40-42</td>
                                                            <td>28</td>
                                                            <td>9</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="skipAndContinue">
                                                <a href="" data-bs-dismiss="modal" aria-label="Close" class="skipButtonItem">Skip</a>
                                                <a href="" class="continueButtonItem">Continue</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="tab-pane" id="tabItem2">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="leftImageItem">
                                                <img src="assets/images/pant.png" alt="" />
                                                <div class="contentItemSugge">
                                                    <h4>David Major | Pants</h4>
                                                    <p>Light Gray Stretch Material</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-md-12">
                                            <div class="table-responsive">
                                                <table class="table table-bordered table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Size</th>
                                                            <th scope="col">Chest</th>
                                                            <th scope="col">Side Length</th>
                                                            <th scope="col">Sleeve</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>S</td>
                                                            <td>36-38</td>
                                                            <td>26</td>
                                                            <td>8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>M</td>
                                                            <td>38-40</td>
                                                            <td>27</td>
                                                            <td>8.5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>L</td>
                                                            <td>40-42</td>
                                                            <td>28</td>
                                                            <td>9</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="skipAndContinue">
                                                <a href="" data-bs-dismiss="modal" aria-label="Close" class="skipButtonItem">Skip</a>
                                                <a href="" class="continueButtonItem">Continue</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="tab-pane" id="tabItem3">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="leftImageItem">
                                                <img src="assets/images/shrit.png" alt="" />
                                                <div class="contentItemSugge">
                                                    <h4>David Major | Shirt</h4>
                                                    <p>Light Gray Stretch Material</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-3">
                                        <div class="col-md-12">
                                            <div class="table-responsive">
                                                <table class="table table-bordered table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Size</th>
                                                            <th scope="col">Chest</th>
                                                            <th scope="col">Side Length</th>
                                                            <th scope="col">Sleeve</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>S</td>
                                                            <td>36-38</td>
                                                            <td>26</td>
                                                            <td>8</td>
                                                        </tr>
                                                        <tr>
                                                            <td>M</td>
                                                            <td>38-40</td>
                                                            <td>27</td>
                                                            <td>8.5</td>
                                                        </tr>
                                                        <tr>
                                                            <td>L</td>
                                                            <td>40-42</td>
                                                            <td>28</td>
                                                            <td>9</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="skipAndContinue">
                                                <a href="" data-bs-dismiss="modal" aria-label="Close" class="skipButtonItem">Skip</a>
                                                <a href="" class="continueButtonItem">Continue</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>




            <div class="modal fade" tabindex="-1" id="alterationsCoatModal">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">

                        <div class="modal-body p-0">
                            <div class="alterModalContent">
                                <div class="leftImage">
                                    <img src="assets/images/modal.png" alt="" />
                                </div>
                                <div class="contentModalRight">
                                    <div class="modal-header plModal">
                                        <h5 class="modal-title f12Size">Messages </h5>
                                        <a href="#" class="close" data-bs-dismiss="modal" aria-label="Close">
                                            <em class="icon ni ni-cross-c"></em>
                                        </a>
                                    </div>

                                    <h3>Cost for sleeve alterations are $6.00 per coat</h3>
                                    <p>Please allow 1/2" tolerance.</p>
                                    <a href="" class="okayBtn" data-bs-dismiss="modal" aria-label="Close">Okay</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </Container >
    )
}

export default GroomStyle
